const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7ab5b1",
      stroke: "none"
    },
    d: "M0 0L0 332C42.8109 317.137 76.9194 288.424 116 266.568C126.56 260.662 137.53 252.865 149 249L148 252C162.274 241.305 174.287 226.16 188 214.439C214.543 191.753 242.619 170.266 264.727 143C290.703 110.964 305.817 73.7311 315.247 34C317.952 22.6022 322.356 11.8484 323 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#edcd8e",
      stroke: "none"
    },
    d: "M323 0C320.27 29.3562 310.688 59.2378 298.684 86C294.839 94.5732 290.521 102.842 285.853 111C284.123 114.023 280.444 118.291 281.067 122C282.708 131.783 303.184 142.894 311 147.758C349.198 171.53 393.65 171.625 434 153.119C477.87 133 503.091 86.226 538 54.8069C545.617 47.9518 553.752 38.7078 563 34.071C570.854 30.1329 591.719 38.7882 600 41.3438C637.505 52.9182 670.218 69.618 695 101L689 103L689 104C702.745 101.377 716.181 93.6923 730 90.1688C746.047 86.0773 763.553 86 780 86C781.598 55.8137 797.287 28.9771 803 0L323 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1c39d",
      stroke: "none"
    },
    d: "M803 0C794.674 27.8132 780.845 56.4741 780 86C809.862 89.899 836.406 99.4064 862 115.436C890.405 133.225 915.047 156.09 950 159.104C969.3 160.769 988.619 157.078 1006 148.241C1011.35 145.523 1019.71 142.052 1022.85 136.667C1027.87 128.079 1024 107.873 1024 98L1024 0L803 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42a7bb",
      stroke: "none"
    },
    d: "M318 21L304 72L305 72L316.341 36L318 21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1daad",
      stroke: "none"
    },
    d: "M279 122C259.059 152.299 232.591 176.193 205 199.409C188.304 213.457 167.921 227.251 155 245C194.956 231.896 233.605 202.255 278 207.306C347.97 215.267 409.086 268.804 482 253.463C530.774 243.2 571.507 212.768 605.997 178C631.328 152.464 656.239 120.021 690 105L689 103L695 101C676.033 67.6121 632.952 50.4071 598 40.4395C589.62 38.0497 569.801 29.694 562 33.98C552.782 39.0446 544.76 47.8228 537 54.8069C502.292 86.0444 477.732 130.766 435 152.169C396.439 171.483 353.604 171.16 316 150.124C302.185 142.396 291.63 131.186 279 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbe8c8",
      stroke: "none"
    },
    d: "M381 240L357 256.204L304 292L304 293L307 293L307 294L304 294L304 295C310.66 294.457 316.751 294.26 322 299C339.539 300.036 356.058 320.99 364 335C351.426 322.426 334.858 316.429 320 309C315.941 306.97 304.212 305.154 305 302L289 301L291 304L265 314L265 315C278.18 313.774 291.691 311.414 305 313.712C337.164 319.266 361.484 346.435 379 372L380 372C393.604 353.762 412.934 331.761 436 326C436 322.516 441.974 321.965 445 321.167C454.406 318.685 462.481 320 472 320C495.341 320 512.784 331.077 524.333 351C529.083 359.194 533.846 364.976 532 375C535.363 375 534.119 381.153 534 384C533.644 392.533 531.312 404.725 526.5 412C516.197 427.575 504.576 444.767 488 454.667C479.751 459.593 470.863 461.735 462 465C474.247 452.753 477.381 439.857 482 426C483.277 422.17 484.864 413.466 487 414L487 392C482.823 392 479.321 373.956 474 371C460.496 363.498 448.519 369.49 435 367L419 376.167L392 398L380 411C370.436 406.218 364.384 392.038 355 385C340.732 374.299 324.965 368.241 308 364C297.917 361.479 284.879 366.162 279 374C276.11 377.853 272.504 390.626 270 390C271.928 400.617 270.527 411.371 272.901 422C278.864 448.691 293.541 476.027 309.432 498C317.04 508.519 325.378 521.65 337 528L337 529L320 521L321 519C281.923 496.213 236.342 453.266 225.09 408C221.049 391.746 223.569 374.38 225 358L224 358C220.321 376.775 200.261 391.832 190.19 408C162.841 451.909 136.425 501.224 90 527.853C75.7472 536.028 58.753 544.904 42 545L42 546C78.3213 556.308 110.148 580.261 120.94 618C124.974 632.106 125 646.484 125 661L126 661L126 652C163.761 664.35 196.073 686.733 222.226 716.568C241.457 738.507 255.204 764.645 278 783.507C309.382 809.475 349.128 819 389 819C380.643 798.154 365.791 780.708 364.35 757.011C363.949 750.419 371.55 749.334 371 743L367 744C367 721.486 371.794 702.567 377 681C367.902 676.946 359.615 667.766 363.166 657C364.747 652.208 369.016 648.867 370 644C376.794 641.98 383.002 639.524 389.998 642.589C392.835 643.832 398.008 647.137 394.568 650.59C389.859 655.317 380.99 645.982 374.353 652.462C369.623 657.08 369.101 674.048 378.807 673.29C385.981 672.73 393.727 657.351 399.196 652.9C412.281 642.25 427.408 635.883 442 627.676C448.854 623.821 455.339 618.012 463 616L463 615C440.232 603.752 439.281 577.332 458 562L457 560C474.615 552.554 483.98 553.126 499 565L499 566L493 573L492 573C470.029 546.507 438.96 594.533 469.001 605.939C472.384 607.223 476.446 607.245 480 606.772C485.371 606.057 489.536 602.788 494 600L494 599L491 599C514.402 575.597 538.395 549.822 557.839 523C567.893 509.131 575.151 490.058 587 478L600.44 517L611 532C598.46 509.728 590.506 486.641 583.842 462C580.942 451.28 576.606 440.143 576 429L575 429C568.551 443.888 565.741 471.003 551.882 480.844C540.187 489.149 528.809 480.059 517 477.253C501.752 473.63 485.548 475 470 475C463.636 475 455.245 473.572 449.142 475.521C443.754 477.242 440.392 484.991 436.793 488.997C430.291 496.234 421.955 502.441 414 508C425.079 495.669 438.743 471.518 433.352 454.028C426.939 433.221 400.867 451.567 395 462C387.375 453.653 361.504 435.87 353.845 455.015C351.512 460.846 354.468 468.043 355 474C358.423 474 359.146 480.051 360.333 483C364.484 493.305 370.008 502.008 378 510L353.028 490L341.776 477.15L312 475L312 474L338 473C336.104 462.982 326.394 448.477 334 439C333.957 431.408 340.609 424.871 348 424C352.875 419.603 358.773 420.001 365 420L365 421L363 421L363 422C376.523 423.373 387.269 432.623 394 444L395 444C404.246 427.748 416.984 421 435 421L435 422L433 422L433 423C452.231 424.982 456 438.31 456 455L454 454L451 467C472.115 467 495.134 463.608 516 466.224C524.521 467.293 535.332 476.401 543.874 471.715C549.202 468.792 551.162 461.342 552.993 456C557.118 443.962 561.394 431.975 565.701 420C567.401 415.275 570.816 402.966 577.94 405.001C585.659 407.206 586.243 424.474 587.875 431C594.38 457.022 600.553 483.605 612 508C619.937 493.853 623.539 467.161 624 451L623 451L612 503C605.569 491.415 596.377 470.426 596.6 457C596.677 452.355 599.933 448.37 601.166 444C603.549 435.552 604.712 424.782 604.973 416C606.506 364.315 601.587 308.989 629.403 263C643.137 240.292 663.389 221.847 690 216.683C729.63 208.993 759.076 249.642 790 266.668C797 270.523 805.053 273.527 813 274.667C820.562 275.752 826.987 274.229 834 278C825.458 260.518 811.05 245.759 802.252 228C780.294 183.676 773.551 134.638 780 86C746.761 86 713.158 90.1572 684 107.475C646.952 129.479 620.759 163.656 590 192.941C566.672 215.15 536.541 235.983 506 246.885C462.467 262.426 423.324 253.844 381 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aad2c4",
      stroke: "none"
    },
    d: "M780 86C765.301 164.469 799.369 247.028 856 300.941C889.293 332.635 929.421 351.794 947.397 397C951.483 407.275 957.915 422.704 955.588 434C952.751 447.775 935.136 462.655 926.279 473C907.245 495.231 890.403 517.449 879.817 545C865.33 582.708 874.315 622.947 869.692 662C862.885 719.494 831.115 764.797 790 803.941C766.479 826.334 739.575 845.161 710 858.676C677.711 873.43 644.667 882.594 615 903.035C573.128 931.886 545.468 977.024 528 1024L571 1024C575.899 1024 584.258 1025.58 588.552 1022.85C595.73 1018.29 600.509 1004.01 605.358 997C616.602 980.743 629.533 965.811 646 954.679C670.76 937.941 699.394 928.599 725 913.39C755.846 895.069 780.9 870.711 803.383 843C845.782 790.741 877.101 727.505 947 708.65C958.799 705.467 970.864 704.999 983 705C997.02 705.001 1010.7 707.657 1024 712L1024 613C1024 602.571 1027.85 582.829 1023.28 573.451C1021.17 569.104 1012.97 566.921 1009 564.532C999.415 558.758 990.696 551.552 983.46 543C959.003 514.092 956.277 474.273 957.066 438.01C957.18 432.766 960.724 429.33 963.208 424.997C968.031 416.587 972.289 407.911 976.108 399C984.845 378.615 991.263 357.231 1000.33 337C1007.09 321.918 1017.54 307.453 1023.09 292C1027.84 278.751 1024 258.053 1024 244L1024 137C1003.49 147.579 985.185 159.642 961 159.962C922.407 160.474 894.562 135.571 864 116.066C838.435 99.7493 810.34 88.647 780 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e4ca",
      stroke: "none"
    },
    d: "M0 542C17.6491 542 36.7342 548.087 54 543.937C119.246 528.256 155.112 465.661 187.691 413C202.614 388.879 223.468 371.312 230 343L247.999 325.502L255 318L265 316L278.941 310.925L291 304L289 301L293 300L293 299L281 300C287.341 294.408 298.869 294.017 307 294L307 293L304 293L304 292L381 242L381 240C347.223 224.419 305.942 205.902 268 207.027C240.795 207.834 214.516 218.2 190 229.179C178.907 234.146 164.036 238.441 154.436 245.835C146.028 252.312 139.387 263.165 133.702 272C105.433 315.934 105.211 369.98 80.1246 415C68.5932 435.694 52.113 454.816 33 468.832C26.0598 473.921 18.6945 478.4 11 482.248C7.92146 483.787 2.37216 485.209 0.717335 488.49C-1.32123 492.532 0 499.577 0 504L0 542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e4ca",
      stroke: "none"
    },
    d: "M612 503C618.207 488.091 622.146 467.126 623 451L625 452C625.98 433.316 630.257 413.282 634.217 395C635.299 390.005 637.133 379.042 644 379.042C650.069 379.042 652.054 387.429 652.989 392C656.015 406.791 658.96 422.031 661 437L662 437C661.382 425.216 658.01 413.648 656.281 402C655.66 397.812 653.672 392.189 655.058 388.06C657.905 379.581 669.907 374.426 676.196 368.885C689.46 357.2 704.449 349.71 719.941 341.671C736.233 333.217 751.711 324.333 769.99 320.621C782.648 318.05 793.576 312 806 308.747C812.372 307.079 820.789 306.62 825 301L840 301L842 299L841 297L843 295L848 294L859 304C852.766 295.437 840.839 280.283 830.999 276.035C826.124 273.93 820.158 275.359 815 274.793C807.512 273.972 799.658 271.16 793 267.728C755.335 248.317 726.654 204.496 679 219.06C657.427 225.654 640.754 243.233 629.403 262C601.112 308.775 607.454 363.654 604.941 416C604.532 424.508 603.475 434.815 601.166 443C599.92 447.414 596.765 451.36 596.385 456C595.402 467.986 604.801 493.56 612 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#86c2be",
      stroke: "none"
    },
    d: "M0 487C11.4858 484.132 22.4147 477.022 32 470.268C62.2254 448.97 83.5533 414.839 95.0943 379.997C102.746 356.897 106.753 332.805 115.432 310C120.314 297.174 126.267 284.555 133.702 273C138.779 265.109 146.061 258 149 249L122 262.739L40 313.684L13 326.649L0.717335 333.342L0 347L0 378L0 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85c2c0",
      stroke: "none"
    },
    d: "M1023 292C1002.61 324.802 991.101 361.512 976.528 397C971.72 408.708 959.057 423.103 957.189 435.115C956.06 442.376 958 450.612 958 458C958 504.177 974.254 557.079 1024 572L1024 376L1024 319L1023 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7bf7a",
      stroke: "none"
    },
    d: "M297 294L297 295L304 295L297 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7fcfe",
      stroke: "none"
    },
    d: "M308 294L308 295L322 298L308 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5dfcb",
      stroke: "none"
    },
    d: "M847 294L843 295L841 297L842 299L840 301L825 301C818.519 306.969 809.132 307.374 801.027 309.869C786.244 314.422 771.939 319.453 757 323.764C732.313 330.887 705.463 346.175 685 361.454C676.826 367.557 657.442 377.598 654.659 388.06C653.035 394.165 656.319 403.833 657.432 410C660.2 425.332 661.476 440.805 664.786 456C668.273 472.004 671.576 490.28 681 504L682 504C691.764 489.785 694.305 471.113 699.667 455C702.102 447.68 704.657 438.532 712.028 434.652C727.065 426.736 735.184 455.856 739.021 465C740.377 468.233 742.338 473.987 746.227 474.939C750.083 475.884 753.619 471.329 756 468.999C761.153 463.958 767.998 456.48 776 457.439C789.323 459.037 796.868 474.878 809 479.965C824.128 486.307 837.75 480.136 853 480L853 481C836.873 487.843 819.469 494.599 802 487.092C793.577 483.473 783.198 468.628 774.001 469.509C762.168 470.641 756.307 496.161 742.003 489.432C732.408 484.919 728.842 471.049 725.199 462C723.764 458.435 721.686 450.748 717.075 450.13C711.237 449.347 708.825 464.119 707.712 468C703.501 482.685 698.837 512.798 683.972 520.587C671.736 526.998 664.891 508.569 662.44 500C653.945 470.308 653.512 438.27 644 409L643 409C640.245 439.853 631.617 470.385 626.997 501C625.808 508.884 624.528 528.251 615.969 531.639C609.778 534.09 605.664 526.335 603.327 522C596.112 508.614 590.541 492.773 587 478L576.925 493L557.108 523L491 599L501 606C494.432 614.53 484.64 618.473 474 617.94C469.06 617.692 463.863 615.196 459 616.936C450.365 620.026 442.049 627.066 434 631.568C414.089 642.703 391.699 652.107 381 674L391 673L391 670C403.843 676.527 384.813 685.087 377 681C370.483 702.235 367 721.664 367 744L371 743C370.458 748.367 364.496 749.736 364.161 755.07C362.537 780.88 382.594 812.909 399 831L396 832L396 833L403 833L404 845L405 845L408 834C415.243 838.591 412.004 847.593 412 855L418 855L420 841L426 835C428.824 834.247 432.035 832.891 434.954 833.914C441.432 836.187 437.667 841.089 433 842L433 839C427.423 840.101 421.648 848.382 427.522 853.125C430.604 855.614 435.513 853.401 439 853C435.535 859.655 430.054 860.955 423 861L423 862L436 863C438.021 880.37 454.26 893.585 455.903 911C458.563 939.188 447.182 966.07 433.61 989.997C427.148 1001.39 417.873 1011.82 413 1024L496 1024C503.683 1024 521.045 1027.25 527.49 1022.85C530.779 1020.61 531.77 1014.48 533.292 1011C537.576 1001.21 542.201 991.319 547.433 982C563.016 954.244 582.394 928.049 608 908.764C643.791 881.809 685.946 871.992 725 851.732C780.666 822.853 834.655 771.049 857.925 712C877.824 661.503 863.693 608.374 876.25 557C883.736 526.373 903.653 500.431 923.721 477C933.707 465.341 950.579 450.917 955.345 436C959.312 423.58 950.928 404.278 946.18 393C927.823 349.395 883.927 320.876 847 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc5a00",
      stroke: "none"
    },
    d: "M281 298L281 299L306 302L306 301L290 298L290 297L315 297.951L340 309C325.191 293.705 300.195 292.654 281 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc7c0d",
      stroke: "none"
    },
    d: "M290 297L290 298L306 301L305 303C327.022 308.291 345.004 321.146 363 334C353.234 305.388 316.4 295.618 290 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf9",
      stroke: "none"
    },
    d: "M323 298L323 299L345 311C339.404 304.551 331.136 300.316 323 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4ffff",
      stroke: "none"
    },
    d: "M281 299L281 300L289 300L281 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9feff",
      stroke: "none"
    },
    d: "M290 300L290 301L303 303L290 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffb256",
      stroke: "none"
    },
    d: "M296.667 300.333L297.333 300.667L296.667 300.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbf7e9",
      stroke: "none"
    },
    d: "M304 303L304 304L355 328C345.211 315.936 319.375 304.561 304 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc7c0f",
      stroke: "none"
    },
    d: "M334 527C322.957 511.829 309.283 498.354 298.359 482.973C282.755 461.004 272.878 435.621 269.568 409C266.731 386.176 281.716 357.473 308 361.46C328.605 364.585 344.434 375.874 359 390.027C365.705 396.542 371.753 406.628 380 411C394.52 392.248 414.615 373.327 438 366.767C463.312 359.667 486.117 373.921 487.881 401C489.456 425.173 473.572 443.715 464 464C519.731 452.26 565.096 362.502 502 328.188C494.452 324.083 486.469 321.918 478 320.722C467.986 319.308 456.891 319.724 447 321.902C434.229 324.713 422.513 330.467 412 338.168C399.951 346.994 387.1 358.673 380 372C368.488 356.962 356.628 342.08 341 331.052C310.38 309.447 263.518 303.032 237.502 335C231.864 341.928 227.503 350.367 225.178 359C209.891 415.789 255.006 469.227 296 501.672C307.518 510.787 320.159 521.677 334 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbb26e",
      stroke: "none"
    },
    d: "M294 313L294 314L297 314L294 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fbef",
      stroke: "none"
    },
    d: "M299 313L299 314C311.752 316.396 323.983 320.738 335 327.709C341.887 332.068 347.747 338.398 355 342C343.501 326.419 318.405 313.564 299 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8ffff",
      stroke: "none"
    },
    d: "M255 318L255 319L264 316L255 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcca93",
      stroke: "none"
    },
    d: "M306.667 315.333L307.333 315.667L306.667 315.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafcfb",
      stroke: "none"
    },
    d: "M435 324L435 325L463 320C454.429 316.798 443.233 321.311 435 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffac5e",
      stroke: "none"
    },
    d: "M454 320L454 321L459 321L454 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbb367",
      stroke: "none"
    },
    d: "M476 320L476 321L479 321L476 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffbf3",
      stroke: "none"
    },
    d: "M481 320L481 321L506 330C499.647 323.793 489.759 320.476 481 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faad6e",
      stroke: "none"
    },
    d: "M363.333 333.667L363.667 334.333L363.333 333.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fef9f8",
      stroke: "none"
    },
    d: "M510 333L523 347C520.482 340.935 515.868 335.948 510 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5ffff",
      stroke: "none"
    },
    d: "M230 343L228 349L229 349L230 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfff9",
      stroke: "none"
    },
    d: "M527 354L532 373L533 373C532.796 366.329 531.168 359.324 527 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f75c00",
      stroke: "none"
    },
    d: "M286 365L286 366C312.784 358.435 326.365 371.525 350 381C336.336 365.254 305.196 355.248 286 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fab157",
      stroke: "none"
    },
    d: "M299 362L299 363L306 363L299 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefff4",
      stroke: "none"
    },
    d: "M279 374C283.247 371.14 287.118 367.559 292 365.802C310.046 359.309 325.829 371.551 342 377C329.1 363.705 289.836 353.606 279 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feb565",
      stroke: "none"
    },
    d: "M310.667 363.333L311.333 363.667L310.667 363.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffad5f",
      stroke: "none"
    },
    d: "M451 364L451 365L457 365L451 364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafbff",
      stroke: "none"
    },
    d: "M437 367L437 368C449.898 366.867 458.384 366.435 471 370C462.852 362.643 446.785 363.826 437 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcf9ef",
      stroke: "none"
    },
    d: "M407 384L436 369C427.05 366.474 412.43 377.621 407 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M278 374L271 391L272 391L278 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffbef",
      stroke: "none"
    },
    d: "M533 374L525 414L526 414C531.014 403.12 537.462 385.94 533 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fac68b",
      stroke: "none"
    },
    d: "M532 375L532 386L533 386L532 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5fef8",
      stroke: "none"
    },
    d: "M478 376L485 393L486 393C485.602 386.223 483.157 380.498 478 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43b8c2",
      stroke: "none"
    },
    d: "M613 508L610 508C604.762 481.629 594.208 455.33 587.625 429C586.253 423.51 584.584 404.97 576.039 405.819C569.964 406.422 567.745 417.383 566.063 422C560.97 435.971 557.315 461.416 545.707 471.482C537.112 478.935 527.44 468.127 518.999 466.586C496.754 462.523 472.038 472.971 450 468L448 474L508 474L508 475L506 475L506 476C511.386 476 517.5 475.5 522 477C530.619 479.873 542.656 487.451 552 482C560.825 476.852 563.173 461.308 565 454C566.019 449.923 568.14 441.285 571 442L575 429L576 429L581.63 450L593 495C596.47 495 596.976 501.045 598.167 504C601.056 511.174 605.046 529.978 613 532.667C621.939 535.688 623.475 519.364 624.667 514C627.133 502.902 627.214 491.897 629.333 481C631.841 468.104 635.654 454.131 636 441L637 441L637 443L638 443C637.224 436.778 637.054 430.218 641 425L643 409L645 408L646 408L649 436L651 435L655.085 467.997L658 485C661.955 485 662.55 497.516 662 501C667.049 501 667.849 519.184 675 521.667C679.224 523.133 686.057 522.072 688.5 518C695.362 506.564 702.935 488.495 704 475L706 476C706.805 471.169 708.362 467.342 708 463C707.536 457.438 715.632 444.948 721 453C728.095 463.642 728.392 486.131 743 491C756.644 495.548 763.126 473.114 773 469C776.303 467.624 778.81 471.357 781 473C785.436 476.327 802.552 485.793 802 488C819.872 491.754 836.102 489.153 852 480L852 479C836.593 482.613 820.708 486.178 806 478.06C795.538 472.285 788.689 458.485 776 457.255C761.972 455.895 757.623 474.598 745 477L736 455C729.744 456.251 729.188 428.938 714 434C712.891 434.37 707.62 436.071 707 437C704.015 441.478 700.864 461.966 697 461C694.649 475.728 688.906 490.846 682 504C672.728 495.852 671.323 484.386 669.033 473C665.004 452.979 660.363 433.162 656.915 413C655.428 404.303 655.333 386.776 648.539 380.524C637.318 370.198 633.167 398.002 632.305 404C627.297 438.865 617.743 473.207 613 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfdfa",
      stroke: "none"
    },
    d: "M390 400L407 384C400.411 387.297 393.331 393.383 390 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5eb3b9",
      stroke: "none"
    },
    d: "M91 387L73 426L74 426C79.8323 417.117 93.5769 398.094 91 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fab66d",
      stroke: "none"
    },
    d: "M223.333 392.667L223.667 393.333L223.333 392.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfff3",
      stroke: "none"
    },
    d: "M270 392C270 421.369 277.26 445.465 292 471L293 471L274.161 426L270 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fde6be",
      stroke: "none"
    },
    d: "M269 394L269 409L270 409L269 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafcfb",
      stroke: "none"
    },
    d: "M486 394L486 412L487 412L486 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdcd94",
      stroke: "none"
    },
    d: "M487 397L487 409L488 409L487 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fbfa",
      stroke: "none"
    },
    d: "M224 402C224.89 417.29 233.769 433.464 242 446L243 446L232.203 424L224 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#04a4bb",
      stroke: "none"
    },
    d: "M572 407C577.253 405.518 580.019 406.882 582 412C583.756 405.585 576.087 401.907 572 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15a8bf",
      stroke: "none"
    },
    d: "M571 407C561.874 423.397 553.482 446.555 550 465L551 465L565.702 424L571 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#06a6bd",
      stroke: "none"
    },
    d: "M645 408L646 418L647 418L645 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94cabf",
      stroke: "none"
    },
    d: "M583.333 410.667L583.667 411.333L583.333 410.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafef9",
      stroke: "none"
    },
    d: "M485 413L481 431L482 431C484.199 425.718 486.993 418.616 485 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faab5e",
      stroke: "none"
    },
    d: "M486.333 414.667L486.667 415.333L486.333 414.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#05a7bc",
      stroke: "none"
    },
    d: "M641 414L640 423L641 423L641 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffbf7b",
      stroke: "none"
    },
    d: "M270 415L270 418L271 418L270 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafcfc",
      stroke: "none"
    },
    d: "M348 422L348 423L365 421L348 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffb84b",
      stroke: "none"
    },
    d: "M355 421L355 422L363 422L355 421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcff",
      stroke: "none"
    },
    d: "M414 423L414 424L435 422C428.49 419.567 420.498 421.194 414 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fd9a00",
      stroke: "none"
    },
    d: "M340 472L341 472C336.018 454.491 327.591 431.268 352 424.073C355.559 423.024 359.317 422.808 363 423.207C370.009 423.967 375.503 427.811 382 430C369.993 417.633 343.281 418.515 335.183 435.001C329.67 446.222 334.31 461.749 340 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdad1c",
      stroke: "none"
    },
    d: "M395 444L394 444C386.125 424.938 351.505 413.084 337.921 433.028C332.555 440.905 334.513 454.516 337.459 463C344.456 483.156 357.766 501.013 378 510C367.172 494.839 355.367 481.353 353.327 462C351.696 446.531 370.615 443.08 381 449.605C386.392 452.992 390.093 458.087 395 462C399.571 455.873 404.577 449.026 412 446.206C420.92 442.817 434.681 448.778 435.702 459C437.369 475.705 423.66 492.485 416 506C437.884 496.196 468.014 456.644 450.847 432.063C436.343 411.295 402.91 424.298 395 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f4fa",
      stroke: "none"
    },
    d: "M333 438L334 438L347 424C339.803 423.485 334.372 431.761 333 438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#06a8bc",
      stroke: "none"
    },
    d: "M639 425L637 440L638 440L639 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f4",
      stroke: "none"
    },
    d: "M448 428C453.361 437.531 455 444.096 455 455L456 455C456 445.444 457.471 433.701 448 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00a2c0",
      stroke: "none"
    },
    d: "M572 433L570 440L571 440L572 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#12a8c2",
      stroke: "none"
    },
    d: "M710 435L710 436L723 436C718.881 432.447 714.773 432.838 710 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f85900",
      stroke: "none"
    },
    d: "M274 434C277.59 453.014 290.364 472.194 301 488L302 488L285.994 459L274 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11a8c0",
      stroke: "none"
    },
    d: "M577 435L586 471L587 471C585.395 459.883 582.596 444.772 577 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01a2bc",
      stroke: "none"
    },
    d: "M650 435L652 451L653 451L650 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f8ee",
      stroke: "none"
    },
    d: "M332 439C330.245 448.7 331.778 466.289 340 473L333.82 454L332 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16adc4",
      stroke: "none"
    },
    d: "M706 439L698 462L699 462L706 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0ba7bd",
      stroke: "none"
    },
    d: "M727 440L734 456L735 456L727 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01a0bd",
      stroke: "none"
    },
    d: "M569 441L564 457L565 457L569 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10aac1",
      stroke: "none"
    },
    d: "M636 441L628 491L629 491L634.918 457L636 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdca71",
      stroke: "none"
    },
    d: "M368 445L368 446L372 446L368 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfcf9",
      stroke: "none"
    },
    d: "M360 448L360 449C370.031 447.405 374.538 448.416 384 452C377.818 445.232 368.171 444.71 360 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafbf9",
      stroke: "none"
    },
    d: "M400 456L406 450L400 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4fcfa",
      stroke: "none"
    },
    d: "M433 452C434.812 461.978 432.276 470.353 430 480L431 480C434.247 472.47 438.039 459.371 433 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdc262",
      stroke: "none"
    },
    d: "M435 456L435 464L436 464L435 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#07a8bd",
      stroke: "none"
    },
    d: "M710 456L708 464L709 464L710 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00a2bd",
      stroke: "none"
    },
    d: "M562 461L560 468L561 468L562 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0ba7bf",
      stroke: "none"
    },
    d: "M745 476L745 477C753.163 476.159 759.415 468.298 764 462L745 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6a25f",
      stroke: "none"
    },
    d: "M463 463L462 465L464 465L463 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8dc9c1",
      stroke: "none"
    },
    d: "M493 466L493 467L498 467L493 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00a1c2",
      stroke: "none"
    },
    d: "M501 466L501 467L514 467L501 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78c3c4",
      stroke: "none"
    },
    d: "M451 467L451 468L468 468L451 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#07a2bc",
      stroke: "none"
    },
    d: "M480 467L480 468L498 468L480 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#02a3ba",
      stroke: "none"
    },
    d: "M548 467C541.292 475.016 535.834 471.667 527 470L527 471C532.537 473.129 548.583 477.789 548 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0aa4c7",
      stroke: "none"
    },
    d: "M451 468L451 469L468 469L451 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93cbc5",
      stroke: "none"
    },
    d: "M323 473L323 474L336 474L323 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36afbc",
      stroke: "none"
    },
    d: "M326 475L326 476L342 476C337.744 472.069 331.473 474.985 326 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fbfb",
      stroke: "none"
    },
    d: "M356 473L361 487L362 487L356 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00a9c7",
      stroke: "none"
    },
    d: "M312 474L312 475L336 475L312 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00a0bf",
      stroke: "none"
    },
    d: "M447 476C465.895 471.738 488.642 475 508 475C495.421 470.299 475.444 474 462 474C457.43 474 450.44 472.593 447 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90cfc0",
      stroke: "none"
    },
    d: "M320 475L320 476L326 476L320 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#04a6bf",
      stroke: "none"
    },
    d: "M657 475L658 483L659 483L657 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0aa6bf",
      stroke: "none"
    },
    d: "M704 475L702 485L703 485L704 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19a1bf",
      stroke: "none"
    },
    d: "M516 476L516 477L546 484L546 483L516 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81c8c5",
      stroke: "none"
    },
    d: "M631.333 476.667L631.667 477.333L631.333 476.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18acc1",
      stroke: "none"
    },
    d: "M669 477L678 502L679 502L669 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#12adbe",
      stroke: "none"
    },
    d: "M791 480L803 487L803 486L791 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9eed1",
      stroke: "none"
    },
    d: "M828 489L828 490C836.965 489.478 845.323 485.42 853 481L828 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72c2bf",
      stroke: "none"
    },
    d: "M630.333 481.667L630.667 482.333L630.333 481.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aad5c5",
      stroke: "none"
    },
    d: "M538 484L538 485L544 485L538 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#09a5ba",
      stroke: "none"
    },
    d: "M659 484L662 499L663 499L659 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0eaabd",
      stroke: "none"
    },
    d: "M701 485L689 516L690 516C694.703 508.774 703.598 493.846 701 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11abbd",
      stroke: "none"
    },
    d: "M604 491L610 508L611 508L604 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#12a9bd",
      stroke: "none"
    },
    d: "M594 494L605 523L606 523L594 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0ea9bc",
      stroke: "none"
    },
    d: "M663 500L668 515L669 515L663 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fab963",
      stroke: "none"
    },
    d: "M414 508L417 506L414 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fe961a",
      stroke: "none"
    },
    d: "M378 510L379 511L378 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefdf4",
      stroke: "none"
    },
    d: "M320 520L320 521L335 529L335 528L320 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6ae7d",
      stroke: "none"
    },
    d: "M334 527L337 529L334 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7d4c4",
      stroke: "none"
    },
    d: "M0 542L0 744L1 744L3 740L6 741L9 738L8 735L15 725L17 723L22 721L21 718C30.6324 718.46 39.3852 709.213 48 705.701C52.4011 703.907 56.9484 704.021 60 700L73 696L78 695L78 698L79 698L85 697L85 695L97 698L100 699L102 697L103 697L114 702C136.472 644.004 122.377 578.117 61 551.893C41.9285 543.744 20.4849 542 0 542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffea",
      stroke: "none"
    },
    d: "M457 560L457 561C472.693 556.242 479.271 555.175 495 561C485.148 550.214 468.237 553.58 457 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbffe8",
      stroke: "none"
    },
    d: "M770 555L770 556L781 555L770 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffe1",
      stroke: "none"
    },
    d: "M351 616L352 616L352 557C368.651 557 380.455 558.09 396 564C387.962 555.153 374.133 554.999 363 555C359.757 555 353.544 553.89 351.717 557.412C349.422 561.838 351 570.116 351 575L351 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccceb2",
      stroke: "none"
    },
    d: "M473 555L473 556L479 556L473 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffdea",
      stroke: "none"
    },
    d: "M608 555L608 556L619 556L608 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f8e6",
      stroke: "none"
    },
    d: "M643 579L644 579C647.066 573.124 649.683 559.472 656.153 556.718C664.315 553.245 667.139 562.331 669.575 568C676.313 583.674 682.735 599.563 690 615C691.157 607.106 683.465 595.162 680.228 588C676.235 579.164 673.057 563.397 665.981 556.717C653.557 544.988 644.918 571.317 643 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4fbe3",
      stroke: "none"
    },
    d: "M692 555L692 556L741 556C727.655 551.013 706.275 555 692 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1fbe6",
      stroke: "none"
    },
    d: "M782 555L782 556C791.565 557.4 797.428 562.536 805 568C800.634 559.365 791.342 555.285 782 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefdf1",
      stroke: "none"
    },
    d: "M215 556L215 616L216 616L216 576L215 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffeed",
      stroke: "none"
    },
    d: "M419 556L419 617L430 617L430 616L420 616L420 576L419 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002f46",
      stroke: "none"
    },
    d: "M457 563L481 557C472.961 553.996 462.673 556.759 457 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e636c",
      stroke: "none"
    },
    d: "M486 616L498.5 606L494 600C487.514 603.525 483.244 609.369 475 608.713C447.435 606.521 453.935 564.154 480 564L480 565L478 565L478 566C484.626 565.591 487.694 568.221 492 573L493 573C500.107 564.13 490.691 558.9 482 558L482 557L484 557C456.247 549.954 434.633 585.198 453.294 606.937C462.011 617.092 473.874 617.058 486 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffff3",
      stroke: "none"
    },
    d: "M531 556L524 574L525 574L531 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064354",
      stroke: "none"
    },
    d: "M507 616C511.719 615.999 516.995 617.061 519 612L518 612L509 615C516.152 601.29 521.748 586.312 527.607 572C529.48 567.425 531.497 558.736 537.059 557.454C543.77 555.908 545.911 565.47 547.853 570C554.251 584.917 561.674 599.66 567 615C558.358 614.807 557.273 608.976 554 602L553 602C555.072 612.51 558.553 615.998 569 616C565.732 599.545 555.283 582.398 548.568 567C545.882 560.842 542.705 552.887 534.27 556.717C529.517 558.875 527.62 567.572 525.716 572C519.43 586.623 512.795 601.179 507 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faf9ef",
      stroke: "none"
    },
    d: "M607 556L605 603L606 603C609.969 591.953 611.138 567.074 607 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8db4ac",
      stroke: "none"
    },
    d: "M608 556L608 557L618 557L618 597L619 597L619 556L608 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffee",
      stroke: "none"
    },
    d: "M619 556L619 599L620 599C620 586.363 623.42 567.827 619 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003e50",
      stroke: "none"
    },
    d: "M628 616L640 616C645.095 598.1 658.224 602 674 602L674 601C666.151 601 652.47 598.335 645.342 601.717C637.608 605.387 641.048 614.754 630 615C637.51 600.604 643.456 585.026 649.607 570C651.526 565.312 653.975 555.813 660.857 557.454C668.226 559.211 673.016 579.641 676 586C677.133 578.298 665.156 547.298 653.774 557.717C649.635 561.506 647.745 569.925 645.575 575C639.729 588.669 633.696 602.269 628 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdffef",
      stroke: "none"
    },
    d: "M691 556L691 566L692 566L691 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004053",
      stroke: "none"
    },
    d: "M762 560L762 561C774.375 557.503 781.473 557.701 794 560C785.263 553.439 771.041 554.987 762 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7ba197",
      stroke: "none"
    },
    d: "M216 557L216 616L217 616L217 577L216 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00314b",
      stroke: "none"
    },
    d: "M217 557L217 616L226 616L226 574L225 574L225 615L218 615L218 558L227 558L217 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034257",
      stroke: "none"
    },
    d: "M265 557L265 558L274 558L274 615L267 615L267 574L266 574L265 616L275 616L275 557L265 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#053b53",
      stroke: "none"
    },
    d: "M293 557L293 616L338 616L338 607L303 607L303 608L337 608L337 615L294 615L294 558L336 558L336 564C329.425 564 307.507 560.526 303.15 565.845C300.368 569.241 302 577.831 302 582L303 582L303 566L338 566L338 557L293 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b6b74",
      stroke: "none"
    },
    d: "M352 557L352 616L353 616L353 577L352 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004254",
      stroke: "none"
    },
    d: "M353 557L353 616L376 616L376 615L354 615L354 558L376 558L353 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e636c",
      stroke: "none"
    },
    d: "M354 558L354 615C368.688 615 392.073 619.204 400.353 602.99C404.191 595.472 403.934 586.166 405 578L404 578L404 580L403 580L397 565C383.145 555.964 369.8 558 354 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004c5b",
      stroke: "none"
    },
    d: "M420 557C424.127 575.297 421 597.258 421 616L431 616L431 557L420 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003244",
      stroke: "none"
    },
    d: "M482 557L482 558L498 567C496.313 559.899 488.639 557.391 482 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d636c",
      stroke: "none"
    },
    d: "M509 615L520 612C520.758 599.303 542.084 596.506 551.815 602.15C559.54 606.63 556.049 614.906 567 615C563.063 599.227 554.253 583.922 547.853 569C545.613 563.776 543.659 555.23 536.143 557.417C530.925 558.934 529.014 567.548 527.202 572C521.335 586.411 514.667 600.504 509 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004959",
      stroke: "none"
    },
    d: "M608 557C608 568.765 613.241 597.416 602.854 605.267C594.902 611.277 584.621 595.29 579.933 605.045C576.349 612.505 590.224 615.833 595 616L595 615C591.339 614.553 580.669 611.796 582.435 606.191C583.27 603.541 586.168 604.278 588.002 605.161C593.902 608.005 599.878 611.19 605.539 605.538C614.835 596.256 610 570.1 610 558L617 558L617 599L618 599L618 557L608 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e636c",
      stroke: "none"
    },
    d: "M630 615C642.118 614.896 639.742 601.348 651.001 601.015C656.853 600.841 667.573 599.077 672.733 602.15C680.408 606.719 677.122 614.907 688 615C684.029 599.092 675.813 584.937 669.425 570C667.12 564.609 665.013 555.108 657.15 557.417C652.009 558.926 650.185 567.622 648.393 572C642.488 586.426 635.675 600.484 630 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002f48",
      stroke: "none"
    },
    d: "M692 557L693 566L711 566L711 565L694 565L694 558L741 558C727.655 553.013 706.275 557 692 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d636b",
      stroke: "none"
    },
    d: "M773 557.495C735.056 564.246 746.451 623.01 784 616.37C824.08 609.281 813.483 550.292 773 557.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e626b",
      stroke: "none"
    },
    d: "M218 558L218 615L225 615L225 574L245 601L267 574L267 615L274 615L274 558C259.696 558.011 253.546 574.813 245 585L229 559L218 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f636b",
      stroke: "none"
    },
    d: "M294 558L294 615L337 615L337 608C329.07 608 311.041 611.383 304.412 606.85C300.451 604.142 300.718 592.789 305.216 590.717C312.034 587.577 324.543 590 332 590L332 582L302 582C302 577.709 300.574 570.193 303.15 566.521C307.374 560.498 329.222 564 336 564L336 558L294 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f5f6b",
      stroke: "none"
    },
    d: "M420 558L420 616L421 616L421 577L420 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f626c",
      stroke: "none"
    },
    d: "M422 558L422 615L429 615L429 558L422 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d646c",
      stroke: "none"
    },
    d: "M610 558C610 570.476 615.263 599.115 602.929 606.911C596.446 611.008 584.965 600.098 581.933 605.254C578.231 611.55 591.153 614.738 595 615L595 616L592 616L592 617C625.788 616.931 617 582.288 617 558L610 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e666c",
      stroke: "none"
    },
    d: "M692 558L692 566L693 566L692 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d636c",
      stroke: "none"
    },
    d: "M694 558L694 565L711 565L711 616L722 616L722 565L741 565L741 558L694 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003849",
      stroke: "none"
    },
    d: "M228 560L237 573L228 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fae6",
      stroke: "none"
    },
    d: "M546 560L569 616C558.559 615.992 555.921 611.756 553 602C545.313 602 532.307 599.475 525.286 602.717C516.493 606.778 520.649 615.965 508 616L508 617C511.463 617 516.451 617.83 519.225 615.283C523.351 611.494 522.228 604.861 529.031 604.101C534.334 603.509 545.945 602.193 550.549 605.15C557.177 609.406 556.174 621.596 567.674 617.588C573.059 615.711 567.079 606.112 565.684 603C559.608 589.446 555.213 571.659 546 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00384a",
      stroke: "none"
    },
    d: "M262 561L256 571L262 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00354d",
      stroke: "none"
    },
    d: "M362 565L362 566L386 569C379.989 563.577 369.561 562.943 362 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003349",
      stroke: "none"
    },
    d: "M467 566L467 567L480 565L467 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c9af",
      stroke: "none"
    },
    d: "M472 565L472 566L478 566L472 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003441",
      stroke: "none"
    },
    d: "M481 565L481 566L489 569L489 568L481 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002b44",
      stroke: "none"
    },
    d: "M722 565L722 566L741 566L722 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9fc2b3",
      stroke: "none"
    },
    d: "M775 565L775 566L782 566L775 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9a94",
      stroke: "none"
    },
    d: "M303 566L303 582L304 582L303 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfee7",
      stroke: "none"
    },
    d: "M363 566L363 607C370.555 607 379.455 607.884 385.972 603.271C397.239 595.295 396.867 576.343 384.989 569.085C378.574 565.165 370.189 566 363 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#668c88",
      stroke: "none"
    },
    d: "M377.667 566.333L378.333 566.667L377.667 566.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003a4f",
      stroke: "none"
    },
    d: "M396 566L403 580L404 580C403.588 574.007 401.366 569.005 396 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1c3b5",
      stroke: "none"
    },
    d: "M692 566L692 567L711 567L692 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97baaa",
      stroke: "none"
    },
    d: "M722 566L722 567L741 567L722 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffe8",
      stroke: "none"
    },
    d: "M753 566C747.338 574.814 747 582.824 747 593L748 593L753 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffeee",
      stroke: "none"
    },
    d: "M767 569L767 570C775.331 567.523 780.448 567.204 789 569C782.88 564.083 773.489 565.49 767 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fce8c8",
      stroke: "none"
    },
    d: "M364 567L364 605C370.403 605 378.221 606.177 383.989 602.83C395.068 596.402 395.779 579.351 385.929 571.494C380.045 566.801 371.14 567.004 364 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcf9e3",
      stroke: "none"
    },
    d: "M692 567L692 568L710 568L710 615L711 615L711 567L692 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdffeb",
      stroke: "none"
    },
    d: "M722 567L722 616L723 616L723 568L741 568L722 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cdddca",
      stroke: "none"
    },
    d: "M759 591L760 591L760 588L761 588C762.27 609.056 781.287 606.306 795 600L796.604 581L791 569C772.417 566.32 759.013 569.208 759 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92b2ae",
      stroke: "none"
    },
    d: "M537.667 568.333L538.333 568.667L537.667 568.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00404f",
      stroke: "none"
    },
    d: "M539 568L549 593L550 593L539 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f9e4",
      stroke: "none"
    },
    d: "M659 568L649 593L670 593L670 592L651 592L659 572L667 590L668 590L659 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004354",
      stroke: "none"
    },
    d: "M660 568L670 593L671 593L660 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#023a55",
      stroke: "none"
    },
    d: "M450 569C445.583 579.662 444.308 590.115 449 601L450 601C447.069 588.501 447.036 580.979 452 569L450 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9e6",
      stroke: "none"
    },
    d: "M537 569L528 593L549 593L539 569L537 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafce7",
      stroke: "none"
    },
    d: "M806 569L809 578L810 578L806 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f4e6",
      stroke: "none"
    },
    d: "M790 570C797.201 580.785 797.466 586.729 794 599L795 599C800.156 589.502 800.845 575.798 790 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003a4c",
      stroke: "none"
    },
    d: "M535 571L526 593L548 594L548 593L528 593L535 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7e1cf",
      stroke: "none"
    },
    d: "M537 572L530 592L546 592C544.955 585.685 542.088 576.128 537 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2decb",
      stroke: "none"
    },
    d: "M659 572L651 592L669 591L659 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003f4d",
      stroke: "none"
    },
    d: "M762 572C757.085 580.863 756.015 592.472 762.62 600.937C772.075 613.053 790.962 610.404 797.69 596.999C800.265 591.868 800 586.584 800 581L799 581C798.961 599.881 778.699 618.789 763.62 598.972C755.838 588.744 763.051 582.212 762 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003842",
      stroke: "none"
    },
    d: "M655 574L653 580L654 580L655 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c9690",
      stroke: "none"
    },
    d: "M391 575L392 576L391 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffde8",
      stroke: "none"
    },
    d: "M446 575C440.225 592.801 449.448 613.801 469 617.497C478.228 619.241 499.374 617.46 500 605C485.882 621.642 459.567 620.371 449.045 600C444.476 591.154 448.144 583.541 446 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffec",
      stroke: "none"
    },
    d: "M523 575L506 616L507 616L519.284 588L523 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ea598",
      stroke: "none"
    },
    d: "M226 576L226 616L227 616C227 604.182 230.136 587.068 226 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#86a094",
      stroke: "none"
    },
    d: "M228 576L229 577L228 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00454f",
      stroke: "none"
    },
    d: "M749 578C746.996 586.886 748.605 596.075 753 604L754 604L749 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f9d9d",
      stroke: "none"
    },
    d: "M809.333 579.667L809.667 580.333L809.333 579.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f4e3",
      stroke: "none"
    },
    d: "M810 579C810 598.146 800.904 616.622 779 616.962C772.121 617.068 766.413 613.92 760 612L760 613C782.627 625.561 821.32 609.291 810 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5fbe5",
      stroke: "none"
    },
    d: "M642 580L637 593L638 593L642 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003247",
      stroke: "none"
    },
    d: "M404 581L404 592L405 592L404 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00304b",
      stroke: "none"
    },
    d: "M332 582L332 590L303 590L303 591L333 591L332 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e777c",
      stroke: "none"
    },
    d: "M333 582L333 591L334 591L333 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bac8b2",
      stroke: "none"
    },
    d: "M445 583L445 589L446 589L445 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9591",
      stroke: "none"
    },
    d: "M456 583L456 589L457 589L456 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#588e81",
      stroke: "none"
    },
    d: "M394 584L394 588L395 588L394 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f8e2",
      stroke: "none"
    },
    d: "M760 588C760.49 603.746 783.557 616.499 793 600C776.948 609.693 767.324 604.043 760 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58958f",
      stroke: "none"
    },
    d: "M798.333 589.667L798.667 590.333L798.333 589.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#579393",
      stroke: "none"
    },
    d: "M748 590L748 593L749 593L748 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00354d",
      stroke: "none"
    },
    d: "M302 591L302 607L303 607L302 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#86a198",
      stroke: "none"
    },
    d: "M303 591L303 607L304 607L303 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7caca8",
      stroke: "none"
    },
    d: "M809.333 591.667L809.667 592.333L809.333 591.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#033544",
      stroke: "none"
    },
    d: "M403 592L401 601L402 601L403 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#729393",
      stroke: "none"
    },
    d: "M404.333 592.667L404.667 593.333L404.333 592.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003544",
      stroke: "none"
    },
    d: "M649 593L649 594L670 594L649 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffded",
      stroke: "none"
    },
    d: "M636 594L627 616L628 616C631.123 610.39 637.338 600.475 636 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003b51",
      stroke: "none"
    },
    d: "M680 594L688 615C679.542 614.811 677.982 609.053 675 602L674 602C676.072 612.51 679.553 615.998 690 616L680 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faf9e3",
      stroke: "none"
    },
    d: "M748 594L752 605L753 605L748 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b9a8c",
      stroke: "none"
    },
    d: "M391 597L392 598L391 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00354e",
      stroke: "none"
    },
    d: "M391 598C382.128 606.562 373.793 607 362 607L362 608C370.142 608 390.18 610.131 391 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#528a88",
      stroke: "none"
    },
    d: "M607.333 598.667L607.667 599.333L607.333 598.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3fee7",
      stroke: "none"
    },
    d: "M586 599C589.591 606.03 595.576 608.015 603 606L603 605C595.37 606.336 592.007 603.274 586 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81978c",
      stroke: "none"
    },
    d: "M449 601L450 602L449 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003f51",
      stroke: "none"
    },
    d: "M461 601C467 610.967 482.497 611.199 490 603C477.509 607.625 472.753 607.61 461 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003a4d",
      stroke: "none"
    },
    d: "M519 611L520 611C526.734 598.286 540.134 602 553 602C541.714 597.782 522.603 598.377 519 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ecefda",
      stroke: "none"
    },
    d: "M640 616L641 616C645.173 605.33 660.058 597.769 671.549 605.15C675.441 607.65 675.351 613.22 678.719 616.155C681.632 618.694 686.423 617.998 690 618L690 617C679.979 614.266 677.201 612.691 674 602C658.85 602 643.496 597.529 640 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74a09b",
      stroke: "none"
    },
    d: "M753 604L754 605L753 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68989f",
      stroke: "none"
    },
    d: "M473 607L473 608L478 608L473 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76a39d",
      stroke: "none"
    },
    d: "M595 607L595 608L600 608L595 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56878a",
      stroke: "none"
    },
    d: "M776 607L776 608L781 608L776 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfde8",
      stroke: "none"
    },
    d: "M615 608C604.329 618.298 597.27 616.504 584 614L584 615C591.97 618.065 614.081 621.592 615 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003144",
      stroke: "none"
    },
    d: "M485 614L485 615L495 610L485 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9eb6a6",
      stroke: "none"
    },
    d: "M378.667 615.333L379.333 615.667L378.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e9796",
      stroke: "none"
    },
    d: "M470.667 616.333L471.333 616.667L470.667 616.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79aba7",
      stroke: "none"
    },
    d: "M601.667 616.333L602.333 616.667L601.667 616.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#749d9b",
      stroke: "none"
    },
    d: "M772.667 616.333L773.333 616.667L772.667 616.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9cb8a9",
      stroke: "none"
    },
    d: "M783.667 616.333L784.333 616.667L783.667 616.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcffe9",
      stroke: "none"
    },
    d: "M370 644L370 645C380.888 642.86 385.568 642.072 396 647C389.682 654.029 379.863 643.891 372.462 652.189C361.289 664.714 376.139 680.497 390 673C385.593 672.46 381.375 674.982 377.038 672.714C368.319 668.154 369.693 654.65 378.014 650.551C383.872 647.665 391.162 655.951 395.487 650.754C398.564 647.055 394.119 643.964 390.996 642.589C383.998 639.509 376.704 641.261 370 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffed",
      stroke: "none"
    },
    d: "M417 641L417 642L446 642L417 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcffed",
      stroke: "none"
    },
    d: "M522 641L522 642L552 642L522 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffee",
      stroke: "none"
    },
    d: "M574 641L574 642L602 642L574 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafee9",
      stroke: "none"
    },
    d: "M625 641L625 642L653 646C646.196 638.783 634.087 641 625 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#598b8a",
      stroke: "none"
    },
    d: "M377.667 642.333L378.333 642.667L377.667 642.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#023e54",
      stroke: "none"
    },
    d: "M370 646L370 647C378.575 644.451 384.222 643.641 393 646C386.257 640.055 377.25 642.037 370 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef0",
      stroke: "none"
    },
    d: "M467 642L467 681L468 681C468 669.455 471.042 652.815 467 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffe9",
      stroke: "none"
    },
    d: "M501 642L501 681L502 681C502 669.455 505.042 652.815 501 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefeea",
      stroke: "none"
    },
    d: "M573 642L573 681L574 681C574 669.455 577.042 652.815 573 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbffed",
      stroke: "none"
    },
    d: "M624 642L624 681L625 681C625 669.455 628.042 652.815 624 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adcbbe",
      stroke: "none"
    },
    d: "M625 642L625 643L644 643L625 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefced",
      stroke: "none"
    },
    d: "M416 643L416 681L417 681L416 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aac9b9",
      stroke: "none"
    },
    d: "M417 643L417 681L418 681L417 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004354",
      stroke: "none"
    },
    d: "M418 643L418 681L445 681L445 676L424 676L424 677L444 677L444 679L419 679L419 644L444 644L444 647L424 647L424 648L445 648L445 643L418 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71a9a0",
      stroke: "none"
    },
    d: "M445 643L445 648L446 648L445 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37767a",
      stroke: "none"
    },
    d: "M468 643L468 681L469 681L468 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003f51",
      stroke: "none"
    },
    d: "M469 643L469 681L474 681L474 653L473 653L473 679L470 679L470 644L477 647L469 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfaed",
      stroke: "none"
    },
    d: "M493 643L493 664L490 662L494 668L493 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e636e",
      stroke: "none"
    },
    d: "M495 643L495 670L494 670C489.864 660.768 480.596 645.872 470 644L470 679L473 679L473 653C482.309 660.472 487.991 680.331 501 681L501 643L495 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00314a",
      stroke: "none"
    },
    d: "M522 643L522 644L551 644L551 647L540 647L540 648L552 648L552 643L522 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d646b",
      stroke: "none"
    },
    d: "M574 643L574 679L601 679L601 677L580 677L580 676L601 676L601 675L580 675L580 663L598 663L598 660L580 660L580 647L602 647L602 643L574 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e656d",
      stroke: "none"
    },
    d: "M625 643L625 681L631 681C631 676.499 632.495 658.892 640 669C644.48 670.71 646.817 675.558 648 680L653 679L645 666C652.445 662.559 659.402 649.216 648.9 644.298C642.276 641.195 632.162 643 625 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f646e",
      stroke: "none"
    },
    d: "M396 676L393 671L392 671C383.04 677.22 370.536 676.39 369.258 663C368.763 657.812 372.211 653.881 373 649C381.048 645.909 385.088 647.632 393 650L395 646C388.638 644.836 382.507 642.954 376.001 644.689C362.626 648.256 357.602 666.671 368.267 676.422C376.396 683.853 387.698 681.397 396 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c626b",
      stroke: "none"
    },
    d: "M419 644L419 679L444 679L444 677L424 677L424 676L446 677C441.671 672.712 429.846 675 424 675L424 663L441 663L441 660L423 660C423.002 644.896 431.21 647 444 647L444 644L419 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d636c",
      stroke: "none"
    },
    d: "M522 644L522 648L534 648L534 681L535 681L535 648L536 648L536 679L539 679C539 665.741 533.626 647.013 551 647L551 644L522 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003b4d",
      stroke: "none"
    },
    d: "M373 649L373 650C380.04 648.353 392.573 652.983 396 647L393 650C385.556 646.917 380.549 645.181 373 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003349",
      stroke: "none"
    },
    d: "M580 647L580 648L602 648L580 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#023e53",
      stroke: "none"
    },
    d: "M632 647L632 648C641.19 648.001 651.027 649.415 647 661C659.876 651.119 638.655 647 632 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fce1",
      stroke: "none"
    },
    d: "M654 647C656.014 655.633 655.362 662.497 646 666L651 672L649 667C656.331 662.849 659.661 654.046 654 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003245",
      stroke: "none"
    },
    d: "M423 648L423 660L441 660L441 663L424 663L424 664L443 664L443 659L424 659L423 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9bb6ae",
      stroke: "none"
    },
    d: "M424 648L424 649L445 649L424 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87aea5",
      stroke: "none"
    },
    d: "M522 648L522 649L534 649L522 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003647",
      stroke: "none"
    },
    d: "M535 648L535 681L540 681L540 648L539 648L539 679L536 679L535 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#709f99",
      stroke: "none"
    },
    d: "M540 648L540 681L541 681L541 649L552 649L540 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94b7b0",
      stroke: "none"
    },
    d: "M580 648L580 659L581 659L581 649L602 649L580 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#568b8a",
      stroke: "none"
    },
    d: "M631 648L631 662L632 662L631 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7c2ba",
      stroke: "none"
    },
    d: "M632 648L632 649L644 649L632 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003e49",
      stroke: "none"
    },
    d: "M653 648C654.021 655.857 653.474 660.848 646 665L646 666C654.111 664.093 657.821 655.053 653 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffde9",
      stroke: "none"
    },
    d: "M424 649L424 658L443 658L443 657L425 657L425 650L445 650L424 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffeed",
      stroke: "none"
    },
    d: "M522 649L522 650L533 650L533 681L534 681L534 649L522 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M541 649L541 681L542 681L542 650L552 650L541 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fee6",
      stroke: "none"
    },
    d: "M581 649L581 659L599 658L599 657L582 657L582 650L602 650L581 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8e8",
      stroke: "none"
    },
    d: "M632 649L632 662L646 661L646 660L633 660L633 650C640.308 650.001 647.251 649.898 647 659C653.932 648.685 638.031 649 632 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0dfca",
      stroke: "none"
    },
    d: "M633 650L633 660L647 661L648 660C646.829 650.021 642.102 650 633 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e5e1c1",
      stroke: "none"
    },
    d: "M126 652L126 661L125 661L125 659L124 659C120.382 686.285 109.01 713.17 114.338 741C120.873 775.135 150.132 794.309 181 804.666C231.425 821.584 286.814 826.171 326.99 865.059C354.779 891.958 371.258 935.477 370.997 974C370.882 990.877 365.885 1007.28 365 1024L397 1024C401.346 1024 407.648 1025.13 411.685 1023.28C418.686 1020.08 424.492 1005.54 428.567 999.196C445.047 973.528 460.472 940.459 455.799 909C453.334 892.411 439.05 879.48 436 863L423 862L424 859C416.336 855.584 411.25 863.175 405 856C393.659 863.673 390.012 856.402 391 845L392 845L392 847L393 847C393.015 843.52 395.027 838.881 391 838L391 837L400 835L397 853C406.559 852.914 405.602 839.481 403 833L396 833L396 832L399 831L390 818C380.651 820.109 370.422 818.376 361 817.304C330.938 813.884 299.887 802.191 277 781.793C255.848 762.942 241.739 738.916 223.704 717.432C199.064 688.08 163.931 661.096 126 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#548589",
      stroke: "none"
    },
    d: "M655 652L655 658L656 658L655 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c9f97",
      stroke: "none"
    },
    d: "M474 653L474 681L475 681L474 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefff0",
      stroke: "none"
    },
    d: "M475 654L475 681L476 681L476 658L480 661L475 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#719597",
      stroke: "none"
    },
    d: "M362 658L362 664L363 664L362 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8c7ba",
      stroke: "none"
    },
    d: "M424 658L424 659L443 659L424 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c3b9",
      stroke: "none"
    },
    d: "M582 658L582 659L599 659L582 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002e45",
      stroke: "none"
    },
    d: "M580 659L580 660L598 660L598 663L580 663L580 664L599 664L599 659L580 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74a6a4",
      stroke: "none"
    },
    d: "M488 661L489 662L488 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003448",
      stroke: "none"
    },
    d: "M631 662L631 663L647 662L631 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b9b96",
      stroke: "none"
    },
    d: "M580 664L580 675L581 675L580 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffec",
      stroke: "none"
    },
    d: "M581 664L581 675L603 675L603 674L582 674L582 666L599 666L599 665L581 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffed",
      stroke: "none"
    },
    d: "M424 665L424 675L446 675L446 674L425 674L425 666L443 666L424 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002d41",
      stroke: "none"
    },
    d: "M632 666L632 667L640 667L632 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004056",
      stroke: "none"
    },
    d: "M645 666L653 679L649 679L649 681L656 681L645 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#598c8c",
      stroke: "none"
    },
    d: "M631 667L631 681L632 681L631 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8fb4a9",
      stroke: "none"
    },
    d: "M632 667L632 668L640 668L632 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafcea",
      stroke: "none"
    },
    d: "M485 668L494 680L485 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfded",
      stroke: "none"
    },
    d: "M632 668L632 681L633 681L633 669L640 669L632 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003f4c",
      stroke: "none"
    },
    d: "M641 668L648 678L641 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffeb",
      stroke: "none"
    },
    d: "M391 670L391 671L396 676L378 682L378 683C384.568 682.961 406.398 675.084 391 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbe9",
      stroke: "none"
    },
    d: "M642 672L649 681L642 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004658",
      stroke: "none"
    },
    d: "M601 675L580 676L580 677L601 677L601 679L574 679L574 681L602 681L601 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#588d8b",
      stroke: "none"
    },
    d: "M445 677L445 681L446 681L445 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffeb",
      stroke: "none"
    },
    d: "M655 677L656 681L649 681L649 682L658 681L655 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#488784",
      stroke: "none"
    },
    d: "M378 681L378 682L385 682L378 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef2",
      stroke: "none"
    },
    d: "M417 681L417 682L446 682L417 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfded",
      stroke: "none"
    },
    d: "M574 681L574 682L602 682L574 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1cabe",
      stroke: "none"
    },
    d: "M77 695L73 696L60 700L46.9729 705.633L21 718L22 721L17 723L15 725L9 738L6 741L3 740C-1.64714 747.955 0 758.065 0 767L0 821L0 1024L365 1024C366.644 1005.59 371.526 987.651 370.973 969C369.62 923.431 347.244 875.321 309 849.677C268.204 822.321 219.665 819.344 175 802.183C146.754 791.33 122.098 772.723 114.771 742C111.094 726.58 114.66 712.334 116 697L115 697L114 702L103 697L102 697L100 699L97 698L85 695L85 697L78 698L77 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83bbbe",
      stroke: "none"
    },
    d: "M589 1024L1024 1024L1024 791L1024 733C1024 727.822 1026.21 715.864 1022.28 711.926C1016.13 705.753 997.262 705.146 989 705.01C956.762 704.481 925.886 710.938 899 729.735C841.068 770.238 813.27 841.599 760 887.688C724.875 918.078 680.331 929.709 643 956.052C620.162 972.169 600.028 998.264 589 1024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01585f",
      stroke: "none"
    },
    d: "M472 728L467 729L467 730L472 730C471.529 739.002 472.548 758.786 461 760C464.78 765.002 470.794 760.881 472.594 755.986C477.375 742.984 473.542 728.089 477.78 715.042C479.462 709.865 485.122 710.745 487 706C474.207 706.88 472.931 717.334 472 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#095b5d",
      stroke: "none"
    },
    d: "M362 725C358.519 725.055 355.113 725.152 352.071 727.089C340.587 734.398 348.134 757.938 358.217 743.972C359.532 742.149 360.241 740.087 361 738L362 738C360.82 743.388 362.45 751.964 369 746C360.207 740.236 366.948 719.08 367 710L366 710L366 714L365 714L368 708C361.475 708.791 362.676 719.825 362 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c9a9a",
      stroke: "none"
    },
    d: "M367 707L368 708L367 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b9292",
      stroke: "none"
    },
    d: "M363 709L363 712L364 712L363 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d737b",
      stroke: "none"
    },
    d: "M365 709L365 714L366 714L366 710L367 710L367 713L368 713L368 709L365 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9dbbb4",
      stroke: "none"
    },
    d: "M483.667 710.333L484.333 710.667L483.667 710.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5fee7",
      stroke: "none"
    },
    d: "M577 710L577 711C580.787 713.6 578.301 715.936 575 713C573.94 721.769 588.823 712.386 577 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f5e1",
      stroke: "none"
    },
    d: "M636 710L636 711C639.787 713.6 637.301 715.936 634 713C632.937 721.794 647.605 712.403 636 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002c42",
      stroke: "none"
    },
    d: "M379 716C382.367 715.292 383.327 714.473 383 711L379 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00243a",
      stroke: "none"
    },
    d: "M429 716C432.707 715.601 434.361 714.914 434 711L429 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c3e4a",
      stroke: "none"
    },
    d: "M576 716C579.367 715.292 580.327 714.473 580 711L576 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003044",
      stroke: "none"
    },
    d: "M635 716C638.367 715.292 639.327 714.473 639 711L635 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002b32",
      stroke: "none"
    },
    d: "M695 716L695 715L693 713L696 713L696 711C692.406 711.683 690.539 715.044 695 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00364a",
      stroke: "none"
    },
    d: "M279 728L277 718L278 718L291 741L290 741C289.389 736.578 287.947 734.142 284 732C292.333 744.922 280.41 744.318 271 742C272.199 752.836 289.015 750.033 291.468 740.989C294.231 730.801 279.436 728.55 280.366 720.042C280.859 715.525 285.66 715.562 289 716L289 715L284 714L284 713L292 715L290 719C294.447 716.073 291.784 712.411 286.996 712.14C277.689 711.612 272.041 721.385 279 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f6e73",
      stroke: "none"
    },
    d: "M696 712L693 713L696 716L696 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#196c6f",
      stroke: "none"
    },
    d: "M284 713L284 714L292 717L284 713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c7075",
      stroke: "none"
    },
    d: "M380 715L383 713L380 715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e7175",
      stroke: "none"
    },
    d: "M636 715L639 713L636 715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#337173",
      stroke: "none"
    },
    d: "M691 713L691 716L692 716L691 713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#046168",
      stroke: "none"
    },
    d: "M297 728L297 729C304.524 733.668 297.061 744.803 306 748L306 747C298.472 739.34 303.506 727.422 304 718L306 719L306 714L297 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03545d",
      stroke: "none"
    },
    d: "M664 727L664 729L669 729C668.766 737.222 669.38 758.945 682 744C670.52 746.51 672.305 735.971 673 728L679 728L679 727L674 727L675 714L664 727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c9597",
      stroke: "none"
    },
    d: "M302 715L303 716L302 715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97bbae",
      stroke: "none"
    },
    d: "M477 715L477 718L478 718L477 715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#628f8d",
      stroke: "none"
    },
    d: "M380.667 716.333L381.333 716.667L380.667 716.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48827f",
      stroke: "none"
    },
    d: "M430 716L430 717L433 717L430 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7daaa6",
      stroke: "none"
    },
    d: "M577.667 716.333L578.333 716.667L577.667 716.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68a39a",
      stroke: "none"
    },
    d: "M636.667 716.333L637.333 716.667L636.667 716.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e8483",
      stroke: "none"
    },
    d: "M692.667 716.333L693.333 716.667L692.667 716.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7ba9a2",
      stroke: "none"
    },
    d: "M362 717L362 722L363 722L362 717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#12696d",
      stroke: "none"
    },
    d: "M277 718L290 741L291 741L277 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#669594",
      stroke: "none"
    },
    d: "M301 718L301 721L302 721L301 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00414f",
      stroke: "none"
    },
    d: "M304 718C303.279 726.204 297.886 741.302 306 747L306 748C299.389 744.297 301 736.647 301 730L300 730C298.802 739.176 301.057 757.433 313 744C301.52 746.51 303.305 735.971 304 728L315 725L304 726L304 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ac9d",
      stroke: "none"
    },
    d: "M366 718L366 721L367 721L366 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8b8b",
      stroke: "none"
    },
    d: "M670 718L670 721L671 721L670 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9f8e",
      stroke: "none"
    },
    d: "M279 719L279 722L280 722L279 719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9cb3a3",
      stroke: "none"
    },
    d: "M305.333 719.667L305.667 720.333L305.333 719.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83b5aa",
      stroke: "none"
    },
    d: "M472.333 722.667L472.667 723.333L472.333 722.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#529097",
      stroke: "none"
    },
    d: "M476 722L476 725L477 725L476 722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faf6e1",
      stroke: "none"
    },
    d: "M707 725L707 726C711.297 724.964 723.021 723.839 716 731C720.32 731.512 722.542 726.724 718.753 723.855C715.063 721.061 710.553 723.205 707 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff7e9",
      stroke: "none"
    },
    d: "M441 723L441 724C446.424 726.876 446.446 730.338 446 736C450.063 730.388 447.825 724.327 441 723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbe5",
      stroke: "none"
    },
    d: "M454 723L454 724C461.308 729.745 461 737.415 461 746L464 745C459.948 737.293 464.406 726.464 454 723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f9e6",
      stroke: "none"
    },
    d: "M488 749C481.819 738.08 486.596 725.666 500 724C487.171 719.485 476.391 742.043 488 749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffee6",
      stroke: "none"
    },
    d: "M516 728L513 724L515 734L516 734C517.591 729.725 525.064 720.887 526 730C521.884 729.487 520.037 730.38 518 734L532 730L532 741L533 741L532 728L529 729L533 724L528 727C524.457 721.309 520.059 724.362 516 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffed",
      stroke: "none"
    },
    d: "M533 723L533 724C537.934 728.176 537.3 732.013 537 738L538 738L542 726L541 726L540 729L539 729L533 723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f5e4",
      stroke: "none"
    },
    d: "M604 741C598.933 742.417 595.066 744.287 592 739C597.827 738.057 611.895 726.526 599.899 723.443C588.443 720.499 579.453 739.403 586.73 747.538C592.329 753.799 604.701 749.43 604 741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003c55",
      stroke: "none"
    },
    d: "M645 743C643.774 749.715 652.222 750.585 656.702 747.155C665.226 740.628 652.734 736.309 651.867 730.891C651.079 725.969 659.078 730.026 660.303 727.287C662.973 721.317 649.781 725.072 647.732 728.146C644.454 733.064 660.703 747.983 649.062 744.521C647.708 744.119 646.326 743.48 645 743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1bdad",
      stroke: "none"
    },
    d: "M714.667 723.333L715.333 723.667L714.667 723.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9696",
      stroke: "none"
    },
    d: "M304.333 724.667L304.667 725.333L304.333 724.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47767b",
      stroke: "none"
    },
    d: "M322 724L322 725L325 725L322 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a39c",
      stroke: "none"
    },
    d: "M336.667 724.333L337.333 724.667L336.667 724.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9fbcaa",
      stroke: "none"
    },
    d: "M358.667 724.333L359.333 724.667L358.667 724.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7ea2a1",
      stroke: "none"
    },
    d: "M378.667 724.333L379.333 724.667L378.667 724.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034351",
      stroke: "none"
    },
    d: "M398.001 725.017C385.821 729.262 384.663 754.17 399.989 748.154C410.051 744.205 411.307 720.38 398.001 725.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79a39e",
      stroke: "none"
    },
    d: "M429.667 724.333L430.333 724.667L429.667 724.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcffec",
      stroke: "none"
    },
    d: "M432 724C431.916 729.008 427.633 744.636 434 746L432 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003f53",
      stroke: "none"
    },
    d: "M438 729L441 728L442 738L443 738L442 726L444 737C447.81 730.885 443.596 719.962 438 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76a49f",
      stroke: "none"
    },
    d: "M454.667 724.333L455.333 724.667L454.667 724.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11676c",
      stroke: "none"
    },
    d: "M495 724L495 725C499.565 731.132 494.897 734.225 489 736L489 731C480.629 742.268 494.667 755.753 502 743C495.782 744.658 490.793 745.393 489 738C497.032 736.836 509.087 725.507 495 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a5a6a",
      stroke: "none"
    },
    d: "M507 729L512 728L510 743L512 748C513.577 742.492 515.807 735.767 514.983 730.015C514.105 723.886 509.646 724.314 507 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#013b4d",
      stroke: "none"
    },
    d: "M512 748L511 745L510 745L510 749C518.664 745.576 513.269 730.111 526 730C526.571 723.39 520.928 724.741 517.949 729.043C514.1 734.603 513.478 741.615 512 748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c9995",
      stroke: "none"
    },
    d: "M533.667 724.333L534.333 724.667L533.667 724.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fae5",
      stroke: "none"
    },
    d: "M543 724L543 725C549.158 727.047 550.787 731.904 551 738L552 738L554 730L553 730L552 732C550.404 727.046 548.295 724.554 543 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffeed",
      stroke: "none"
    },
    d: "M574 724L571 746L572 746L576 724L574 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005664",
      stroke: "none"
    },
    d: "M604 743C597.371 744.546 592.78 745.309 590 738C593.929 737.166 599.447 736.507 601.711 732.713C604.76 727.603 600.2 723.107 595.003 725.103C577.305 731.9 589.347 760.628 604 743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#09505d",
      stroke: "none"
    },
    d: "M608 729L611 728L611 749C619.684 745.584 614.436 730.11 627 730C627.888 719.725 618.536 729.195 617 734C615.527 728.753 612.849 720.413 608 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064d56",
      stroke: "none"
    },
    d: "M635 724C631.987 729.479 630.084 738.685 631.308 744.957C632.678 751.982 638.751 747.985 641 744C630.916 746.304 638.536 729.319 635 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004052",
      stroke: "none"
    },
    d: "M702 746L703 746L703 734L704 734L705 743L706 743C705.403 737.798 709.792 721.256 716 731C719.343 728.879 720.047 724.783 714.957 724.344C703.512 723.359 699.66 737.393 702 746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#044952",
      stroke: "none"
    },
    d: "M728 731C742.277 723.636 741.502 749.702 728 744L731 747L731 748C722.646 744.774 724.304 738.252 726 731C714.603 745.186 736.74 757.219 742.27 739.999C743.538 736.051 743.788 729.625 740.588 726.522C736.13 722.199 728.324 725.038 728 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da093",
      stroke: "none"
    },
    d: "M309 725L309 726L314 726L309 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b49f",
      stroke: "none"
    },
    d: "M315.333 725.667L315.667 726.333L315.333 725.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003f4b",
      stroke: "none"
    },
    d: "M318 728L323 726L321 743L322 743L325 725L318 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003344",
      stroke: "none"
    },
    d: "M332 737L333 737L336 726L337 726L336 745L337 745L338 725C333.262 726.872 333.066 732.444 332 737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#789f94",
      stroke: "none"
    },
    d: "M338.333 725.667L338.667 726.333L338.333 725.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#014e59",
      stroke: "none"
    },
    d: "M385 744L377 748L377 735L378 735L378 745L379 745L381 725C370.07 729.183 375.982 758.698 385 744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffee",
      stroke: "none"
    },
    d: "M381 725C380.831 730.921 377.424 741.381 382 746L381 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#116a71",
      stroke: "none"
    },
    d: "M397 726L397 727C404.657 728.48 405.487 734.18 405 741C409.446 733.865 406.015 724.951 397 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffeed",
      stroke: "none"
    },
    d: "M427 725L425 748L426 748L427 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00404a",
      stroke: "none"
    },
    d: "M429 725L431 748C426.42 744.612 428 737.19 428 732L427 732C426.567 736.964 424.309 754.963 434 746C427.121 741.732 431.647 731.731 432 725L429 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073a4b",
      stroke: "none"
    },
    d: "M452 728L456 726L460 746C460.803 741.871 459.38 718.307 452 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#033848",
      stroke: "none"
    },
    d: "M495 749L495 748C484.827 746.593 485.866 738.938 488 731L497 727L497 725C483.765 726.827 479.036 748.645 495 749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#033b4b",
      stroke: "none"
    },
    d: "M529 729C534.219 729.888 533.964 734.494 534 739L535 739L533 726L536 736C538.364 729.672 535.302 722.038 529 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00384f",
      stroke: "none"
    },
    d: "M535 747L534 747L534 741L533 741L533 749C538.367 747.119 542.609 720.978 549 732C549.897 727.189 545.342 724.085 541.719 728.231C537.625 732.913 536.256 741.08 535 747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d6168",
      stroke: "none"
    },
    d: "M556 732C562 735.496 561 741.815 561 748L564 748C564 742.762 565.373 736.039 563.965 731.015C561.901 723.65 557.346 726.336 556 732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003f53",
      stroke: "none"
    },
    d: "M575 725L574 738L575 738L575 731L576 731L577 748L574 740L573 740C573.069 748.027 577.202 750.861 583 744L578 746L578 725L575 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f4d9",
      stroke: "none"
    },
    d: "M628 725L627 730C616.842 728.747 615.176 744.553 610 751C618.902 748.841 615.813 740.143 620.726 734.215C623.716 730.608 629.826 730.823 628 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fbe9",
      stroke: "none"
    },
    d: "M632 725C629.931 732.448 628.954 741.479 631 749L632 749L632 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0c2af",
      stroke: "none"
    },
    d: "M675 725L675 726L682 726L675 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021b34",
      stroke: "none"
    },
    d: "M674 726L674 727L684 725L674 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003445",
      stroke: "none"
    },
    d: "M693 749L693 748C686.294 743.839 690.13 732.665 691 726L692 726L691 746L692 746L693 725C686.353 727.633 684.97 747.297 693 749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f6e0",
      stroke: "none"
    },
    d: "M694 725L692 746L698 744C694.191 747.444 691.946 748.979 687 747C688.763 757.58 699.512 744.628 701 745L703 730L702 730L699 743L694 744L694 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9cbcb1",
      stroke: "none"
    },
    d: "M297 726L297 727L300 727L297 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#126a71",
      stroke: "none"
    },
    d: "M319 727L320 749L326 747C319.086 740.727 322.268 734.196 323 726L319 727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a6567",
      stroke: "none"
    },
    d: "M336 726C334.104 733.386 328.076 754.696 343 746L343 745C331.76 745.502 338.021 732.695 336 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#156e73",
      stroke: "none"
    },
    d: "M428 726C427.147 730.612 425.901 746.907 431 748L430 726L428 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14656b",
      stroke: "none"
    },
    d: "M442 726L440 749L443 749C443.664 742.542 448.262 730.646 442 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e6a6c",
      stroke: "none"
    },
    d: "M452 731C456.69 734.074 456.911 757.88 466 744C456.356 746.062 459.445 732.369 456 726L452 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#116c6f",
      stroke: "none"
    },
    d: "M533 726C534.627 730.568 535.891 734.766 533 739L534 747L535 747C536.667 741 538.753 730.255 533 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e9c9a",
      stroke: "none"
    },
    d: "M578.333 726.667L578.667 727.333L578.333 726.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#619192",
      stroke: "none"
    },
    d: "M665 726L665 727L668 727L665 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#045d69",
      stroke: "none"
    },
    d: "M691 726C690.009 731.455 686.967 757.134 698 744L691 746L691 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#749a99",
      stroke: "none"
    },
    d: "M693 726L693 729L694 729L693 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021933",
      stroke: "none"
    },
    d: "M295 729L300 728L295 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a7f7f",
      stroke: "none"
    },
    d: "M309.667 727.333L310.333 727.667L309.667 727.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fce9ca",
      stroke: "none"
    },
    d: "M362 728C341.793 723.888 354.362 756.485 360.481 735.005C361.135 732.71 361.542 730.339 362 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfdea",
      stroke: "none"
    },
    d: "M375 727C374.164 733.401 371.306 745.447 377 750L375 727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77a8a3",
      stroke: "none"
    },
    d: "M376.333 727.667L376.667 728.333L376.333 727.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#618888",
      stroke: "none"
    },
    d: "M427.333 727.667L427.667 728.333L427.333 727.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6d3c0",
      stroke: "none"
    },
    d: "M446 727L446 732L447 732L446 727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e8588",
      stroke: "none"
    },
    d: "M469 727L469 728L472 728L469 727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003443",
      stroke: "none"
    },
    d: "M476 727L476 729L484 728L476 727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fbea",
      stroke: "none"
    },
    d: "M489 736C503.053 732.092 492.433 722.633 489 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#105965",
      stroke: "none"
    },
    d: "M542 731C548.929 735.038 546.353 742.249 546 749C554.701 747.166 551.216 737.427 551 731C547.474 731 544.417 722.872 542 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8ffed",
      stroke: "none"
    },
    d: "M591 735L597 734L597 733L592 734L598 729L598 727C593.249 727.939 591.653 730.302 591 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#759d91",
      stroke: "none"
    },
    d: "M661 727L662 728L661 727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80b5b3",
      stroke: "none"
    },
    d: "M679.667 727.333L680.333 727.667L679.667 727.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7fae7",
      stroke: "none"
    },
    d: "M720 742L720 741C717.18 741.692 713.148 744.069 710.298 742.698C703.221 739.296 709.132 728.487 716 730C708.588 720.094 698.665 747.675 713.988 744.504C716.125 744.062 718.065 742.956 720 742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbe2cb",
      stroke: "none"
    },
    d: "M397.571 729.251C392.204 732.233 393.413 749.093 400.552 744.809C405.732 741.7 404.507 725.397 397.571 729.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffe9",
      stroke: "none"
    },
    d: "M408 728C408.852 734.835 408.228 740.73 402.854 745.729C397.477 750.731 389.25 749.087 388.279 740.999C387.793 736.953 389.925 732.807 391 729L390 729C388.594 731.573 387.334 734.102 386.723 737.001C381.846 760.14 420.273 747.696 408 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002133",
      stroke: "none"
    },
    d: "M451 728L443 748L444 748L451 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffed",
      stroke: "none"
    },
    d: "M466 728L470 732L467 758L461 758L461 759L468 759L472 730L466 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#749996",
      stroke: "none"
    },
    d: "M483 728L484 729L483 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f6e2",
      stroke: "none"
    },
    d: "M508 728C508.83 731.678 507.692 757.887 515 747L510 749L511 728L508 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003246",
      stroke: "none"
    },
    d: "M511 728L511 744L512 744L511 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c989a",
      stroke: "none"
    },
    d: "M537 728L537 733L538 733L537 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003749",
      stroke: "none"
    },
    d: "M556 728L552 740L553 740L556 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#167375",
      stroke: "none"
    },
    d: "M634 728C633.919 732.826 629.782 746.668 636 748L634 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfceb",
      stroke: "none"
    },
    d: "M673 728C672.141 734.583 670.124 748.411 681 744L681 743C672.747 743.663 674 736.21 674 730L683 729L673 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7ba19d",
      stroke: "none"
    },
    d: "M731 728L732 729L731 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dde2ca",
      stroke: "none"
    },
    d: "M736 746C736.901 744.039 737.878 742.097 738.391 739.987C739.236 736.508 737.922 725.037 731.687 729.327C724.809 734.058 730.176 744.043 736 746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9e6",
      stroke: "none"
    },
    d: "M743 728C744.287 739.026 738.797 750.876 726 749L726 750C737.983 753.184 749.918 739.106 743 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#024256",
      stroke: "none"
    },
    d: "M320 729L319 747L320 747L320 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adccb7",
      stroke: "none"
    },
    d: "M365 729L365 733L366 733L365 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3aa",
      stroke: "none"
    },
    d: "M380 729L380 732L381 732L380 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cddec5",
      stroke: "none"
    },
    d: "M491 734L496 733L496 729L491 734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#759c98",
      stroke: "none"
    },
    d: "M517 729L518 730L517 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7dbcd",
      stroke: "none"
    },
    d: "M592 734L598 734L599 729C595.122 729.411 593.502 730.367 592 734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89b5a2",
      stroke: "none"
    },
    d: "M658.667 729.333L659.333 729.667L658.667 729.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faf9e1",
      stroke: "none"
    },
    d: "M664 729L664 730L667 730C667 740.09 670.088 760.534 683 745C668.844 751.055 666.635 742.023 669 729L664 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58877c",
      stroke: "none"
    },
    d: "M333.333 730.667L333.667 731.333L333.333 730.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89b4a6",
      stroke: "none"
    },
    d: "M361.333 730.667L361.667 731.333L361.333 730.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffdec",
      stroke: "none"
    },
    d: "M395 730L394 744L395 744L395 730z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff8e7",
      stroke: "none"
    },
    d: "M476 730C474.948 742.057 476.712 761.28 461 763L461 764C477.745 763.725 476.992 743.807 477 731L483 731L476 730z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47898d",
      stroke: "none"
    },
    d: "M533 730L533 739L534 739L533 730z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#116069",
      stroke: "none"
    },
    d: "M726 730C724.326 737.158 721.695 745.743 731 748L731 747C725.781 742.22 725.236 736.897 729 731L726 730z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#739f9d",
      stroke: "none"
    },
    d: "M729 730L730 731L729 730z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f8e8d",
      stroke: "none"
    },
    d: "M319.333 731.667L319.667 732.333L319.333 731.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72a496",
      stroke: "none"
    },
    d: "M337.333 731.667L337.667 732.333L337.333 731.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75ab9f",
      stroke: "none"
    },
    d: "M351 731L352 732L351 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#487f7e",
      stroke: "none"
    },
    d: "M408 731L408 737L409 737L408 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdffec",
      stroke: "none"
    },
    d: "M440 731C439.989 736.408 436.953 745.913 441 750L440 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#509390",
      stroke: "none"
    },
    d: "M471 731L471 736L472 736L471 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf5dc",
      stroke: "none"
    },
    d: "M543 731L536 749L537 749L545 733C545 735.93 543.493 754.741 550.423 749.114C554.692 745.646 555.018 738.172 559 734L560 749L561 749L559 732L557 732C553.605 737.489 552.428 746.716 546 749L545 731L543 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a646c",
      stroke: "none"
    },
    d: "M575 731L575 738L574 738L574 734L573 734C573.136 738.784 572.899 744.976 577 748L575 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8e8b",
      stroke: "none"
    },
    d: "M668 731L668 736L669 736L668 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdeb",
      stroke: "none"
    },
    d: "M729 731C727.216 737.559 726.829 745.139 735 746L735 745C727.462 742.452 730.525 737.005 729 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c8d8b",
      stroke: "none"
    },
    d: "M743 731L743 736L744 736L743 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7c8aa",
      stroke: "none"
    },
    d: "M303 732L303 737L304 737L303 732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11676e",
      stroke: "none"
    },
    d: "M391 732C389.2 738.49 387.924 745.966 396 748L391 732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3a1",
      stroke: "none"
    },
    d: "M688 732L688 735L689 735L688 732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00353f",
      stroke: "none"
    },
    d: "M727 732L727 744L728 744L727 732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#acc9c0",
      stroke: "none"
    },
    d: "M460 733L460 744L461 744L460 733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a9c99",
      stroke: "none"
    },
    d: "M517 733L518 734L517 733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70a19e",
      stroke: "none"
    },
    d: "M541 733L542 734L541 733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83b2a8",
      stroke: "none"
    },
    d: "M577 733L577 737L578 737L577 733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b7ab",
      stroke: "none"
    },
    d: "M692 733L692 737L693 737L692 733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3c2b0",
      stroke: "none"
    },
    d: "M426 734L426 737L427 737L426 734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#459090",
      stroke: "none"
    },
    d: "M493.667 734.333L494.333 734.667L493.667 734.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfde7",
      stroke: "none"
    },
    d: "M517 734L515 746L516 746L517 734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#013849",
      stroke: "none"
    },
    d: "M564 734L562 748L562 749L569 747L569 746L565 747L564 734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78a79e",
      stroke: "none"
    },
    d: "M590 734L590 736L592 736L590 734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#437f89",
      stroke: "none"
    },
    d: "M594.667 734.333L595.333 734.667L594.667 734.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13666b",
      stroke: "none"
    },
    d: "M703 734L703 748L714 749L714 748C706.344 744.841 705.797 741.072 703 734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a9089",
      stroke: "none"
    },
    d: "M375 735L375 739L376 739L375 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a7378",
      stroke: "none"
    },
    d: "M377 735L377 748L380 746L380 745L377 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71a4a0",
      stroke: "none"
    },
    d: "M441 735L441 738L442 738L441 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75a496",
      stroke: "none"
    },
    d: "M445 735L445 738L447 737L447 736L445 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6eac95",
      stroke: "none"
    },
    d: "M599 735L600 736L599 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbf8e2",
      stroke: "none"
    },
    d: "M636 735L636 746L641 744L636 749L636 750L641 747L642 747C652.227 756.56 668.726 742.417 656 735C659.536 741.059 658.962 750.915 649.014 749.042C643.682 748.039 642.792 742.61 637 745L636 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57908d",
      stroke: "none"
    },
    d: "M705 735L705 740L706 740L705 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7bdb3",
      stroke: "none"
    },
    d: "M727 735L727 741L728 741L727 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9eaea2",
      stroke: "none"
    },
    d: "M292 736L292 740L293 740L292 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bacbba",
      stroke: "none"
    },
    d: "M322 736L322 743L323 743L322 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7eae9c",
      stroke: "none"
    },
    d: "M379 736L379 745L380 745L379 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57898a",
      stroke: "none"
    },
    d: "M392 736L392 740L393 740L392 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1beae",
      stroke: "none"
    },
    d: "M430 736L430 745L431 745L430 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96a993",
      stroke: "none"
    },
    d: "M318 737L318 740L319 740L318 737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#093e55",
      stroke: "none"
    },
    d: "M331 737L322 743L326 747L321 748L321 749C327.108 748.37 333.161 743.692 331 737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42827f",
      stroke: "none"
    },
    d: "M484 737L484 743L485 743L484 737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#589b95",
      stroke: "none"
    },
    d: "M585 737L585 742L586 742L585 737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b9a0",
      stroke: "none"
    },
    d: "M345 738L345 742L346 742L345 738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2cab7",
      stroke: "none"
    },
    d: "M361 738L360 740L362 740L361 738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d9b94",
      stroke: "none"
    },
    d: "M635 738L635 745L636 745L635 738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8cb3a9",
      stroke: "none"
    },
    d: "M722 738L722 742L723 742L722 738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6aa099",
      stroke: "none"
    },
    d: "M510 740L510 743L511 743L510 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6da39b",
      stroke: "none"
    },
    d: "M611 741L611 744L612 744L611 741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81aaa3",
      stroke: "none"
    },
    d: "M440.333 742.667L440.667 743.333L440.333 742.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9abab1",
      stroke: "none"
    },
    d: "M470 742L470 745L471 745L470 742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#447b7c",
      stroke: "none"
    },
    d: "M501 742L503 744L503 742L501 742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#538e8b",
      stroke: "none"
    },
    d: "M514 742L514 745L515 745L514 742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94baaa",
      stroke: "none"
    },
    d: "M546.333 742.667L546.667 743.333L546.333 742.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003d4d",
      stroke: "none"
    },
    d: "M718 742C713.526 744.972 710.88 745.242 706 743C708.828 747.347 718.905 749.638 718 742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#739f97",
      stroke: "none"
    },
    d: "M490 743L491 744L490 743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4b928b",
      stroke: "none"
    },
    d: "M532 743L532 749L533 749L532 743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60919f",
      stroke: "none"
    },
    d: "M601 743L602 744L601 743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b7ae",
      stroke: "none"
    },
    d: "M615.333 743.667L615.667 744.333L615.333 743.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fdea",
      stroke: "none"
    },
    d: "M719 743C715.708 747.194 712.239 749.122 707 750L707 751C711.897 750.712 719.727 749.324 719 743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#789b97",
      stroke: "none"
    },
    d: "M284 744L285 745L284 744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#467f81",
      stroke: "none"
    },
    d: "M434 744L434 747L436 744L434 744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456e7e",
      stroke: "none"
    },
    d: "M369 745L369 747L371 745L369 745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adceb5",
      stroke: "none"
    },
    d: "M456.333 745.667L456.667 746.333L456.333 745.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c8e8c",
      stroke: "none"
    },
    d: "M710 745L710 746L713 746L710 745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#659292",
      stroke: "none"
    },
    d: "M732.667 746.333L733.333 746.667L732.667 746.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#739aa1",
      stroke: "none"
    },
    d: "M568 747L569 748L568 747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#012c3d",
      stroke: "none"
    },
    d: "M704 747L704 748L712 749L712 748L704 747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b9d9c",
      stroke: "none"
    },
    d: "M715 747L716 748L715 747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da0a0",
      stroke: "none"
    },
    d: "M561 748L562 749L561 748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78a39b",
      stroke: "none"
    },
    d: "M578 748L579 749L578 748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d918b",
      stroke: "none"
    },
    d: "M377.667 749.333L378.333 749.667L377.667 749.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#598f8e",
      stroke: "none"
    },
    d: "M394 749L394 750L398 750L394 749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678f92",
      stroke: "none"
    },
    d: "M428.667 749.333L429.333 749.667L428.667 749.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fa49b",
      stroke: "none"
    },
    d: "M575.667 749.333L576.333 749.667L575.667 749.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7cbbe",
      stroke: "none"
    },
    d: "M648 749L648 750L652 750L648 749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65938a",
      stroke: "none"
    },
    d: "M690.667 749.333L691.333 749.667L690.667 749.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d8c88",
      stroke: "none"
    },
    d: "M728 749L728 750L733 750L728 749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81b1a3",
      stroke: "none"
    },
    d: "M469.333 751.667L469.667 752.333L469.333 751.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98bcb2",
      stroke: "none"
    },
    d: "M473.333 752.667L473.667 753.333L473.333 752.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#024a5c",
      stroke: "none"
    },
    d: "M505 781C495.747 781.323 480.59 794.586 490.845 804.124C496.206 809.111 501.752 798.903 503 795L504 795C504.018 801.373 507.474 809.978 513 801L509 803C506.172 790.464 508.668 776.448 511 764C504.546 766.309 505.17 775.03 505 781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfded",
      stroke: "none"
    },
    d: "M511 764L508 802L513 801L513 800L509 801L511 764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79aea0",
      stroke: "none"
    },
    d: "M510 766L510 769L511 769L510 766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#136873",
      stroke: "none"
    },
    d: "M523 768L522 772L526 768L523 768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b3b48",
      stroke: "none"
    },
    d: "M521 769L521 773L526 769L525 769L522 772L523 769L521 769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f8b88",
      stroke: "none"
    },
    d: "M509.333 772.667L509.667 773.333L509.333 772.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1c9bb",
      stroke: "none"
    },
    d: "M508 781L508 786L509 786L508 781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#033b49",
      stroke: "none"
    },
    d: "M528 801L523 803L522 788L521 788L522 805C517.175 799.824 519.54 789.471 521 783L522 783L522 787L523 787L523 781C515.23 785.821 515.735 814.786 528 801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48928c",
      stroke: "none"
    },
    d: "M499 783L499 784L502 784L499 783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f626f",
      stroke: "none"
    },
    d: "M521 783C519.444 788.715 516.67 801.057 522 805L521 788L522 788L522 791L523 791L521 783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfee6",
      stroke: "none"
    },
    d: "M498 800L498 799C491.294 794.809 495.835 785.743 503 786L501 795C501.936 793.653 502.724 792.523 503.166 790.904C507.509 774.989 480.664 796.323 498 800z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1dfca",
      stroke: "none"
    },
    d: "M499 800L503 786C494.313 784.507 491.179 796.374 499 800z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfbea",
      stroke: "none"
    },
    d: "M489 787C487.04 793.266 486.22 798.87 489 805L490 805L489 787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51928e",
      stroke: "none"
    },
    d: "M518 790L518 793L519 793L518 790z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c6972",
      stroke: "none"
    },
    d: "M488 793L488 801L489 801L488 793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#739896",
      stroke: "none"
    },
    d: "M501 795L502 796L501 795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7ffef",
      stroke: "none"
    },
    d: "M503 795L501 801L503 795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97bbad",
      stroke: "none"
    },
    d: "M517 797L517 803L518 803L517 797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6aa9a9",
      stroke: "none"
    },
    d: "M501 799L502 800L501 799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#abb4af",
      stroke: "none"
    },
    d: "M495.667 800.333L496.333 800.667L495.667 800.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7ea59f",
      stroke: "none"
    },
    d: "M509.667 802.333L510.333 802.667L509.667 802.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6cae9e",
      stroke: "none"
    },
    d: "M510 804L511 805L510 804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffeeb",
      stroke: "none"
    },
    d: "M487 824L487 825L501 825C496.578 821.185 492.173 822.159 487 824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004555",
      stroke: "none"
    },
    d: "M485 838L486 838L485 830L486 830L486 833L487 833C490.504 826.384 494.665 828.12 501 829C498.32 816.667 481.978 826.777 485 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faeb",
      stroke: "none"
    },
    d: "M566 826L571 824L571 829L572 829L572 823L566 826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#023e56",
      stroke: "none"
    },
    d: "M371 826L374 825L371 856C374.409 849.104 375.276 838.664 375.788 831.004C376.004 827.777 374.641 822.611 371 826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b5a66",
      stroke: "none"
    },
    d: "M565 837L559 838L559 839L564 839C564 848.406 564.993 869.647 578 854C566.364 857.535 568 847.714 568 839L572 839L572 838L569 838L569 837L576 837L576 836L569 836L571 824C565.438 826.304 565.288 831.522 565 837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#106972",
      stroke: "none"
    },
    d: "M370 825L368 858L380 857L380 856L371 856L374 825L370 825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70a59c",
      stroke: "none"
    },
    d: "M570.333 826.667L570.667 827.333L570.333 826.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffec",
      stroke: "none"
    },
    d: "M490 827L490 828L497 829L490 827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003e55",
      stroke: "none"
    },
    d: "M370 828L367 859C373.466 859 384.262 861.357 387 854L368 858C370.454 849.175 373.319 836.88 370 828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f7c80",
      stroke: "none"
    },
    d: "M498.667 829.333L499.333 829.667L498.667 829.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e6869",
      stroke: "none"
    },
    d: "M485 830L498 852L499 852C498.684 841.884 491.09 837.218 485 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e8b8c",
      stroke: "none"
    },
    d: "M487 830L487 833L488 833L487 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a9295",
      stroke: "none"
    },
    d: "M483 831L483 835L484 835L483 831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffe7",
      stroke: "none"
    },
    d: "M426 835L426 836C431.555 835.153 438.828 833.998 436 842C445.761 835.887 431.722 832.966 426 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffdea",
      stroke: "none"
    },
    d: "M443 841L444 841C447.527 836.754 451.602 834.894 457 834C451.233 832.088 444.937 835.377 443 841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfce1",
      stroke: "none"
    },
    d: "M632 836L632 837C647.543 833.025 648.096 844.045 644 856C654.14 845.989 646.425 828.253 632 836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefde8",
      stroke: "none"
    },
    d: "M408 834L404 848L405 848L410 834L408 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002e48",
      stroke: "none"
    },
    d: "M420 848L421 848L422 843L423 843C421.665 850.622 423.44 856.563 432 857L432 858C426.646 857.954 422.864 857.517 421 852L420 852C421.048 862.008 432.576 861.711 437 854C434.832 854.577 432.306 855.642 430.026 855.332C418.026 853.7 427.628 831.708 434 841C437.052 839.985 439.204 836.382 434.851 834.836C427.201 832.118 420.676 841.779 420 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#528787",
      stroke: "none"
    },
    d: "M453 834L453 835L457 835L453 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fa69f",
      stroke: "none"
    },
    d: "M488 834L489 835L488 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e8882",
      stroke: "none"
    },
    d: "M517 834L517 835L521 835L517 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafbe4",
      stroke: "none"
    },
    d: "M547 834L547 835C555.149 839.396 554 847.922 554 856L560 855L560 854L556 855C554.254 847.259 557.15 836.001 547 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#639b97",
      stroke: "none"
    },
    d: "M591 834L591 835L595 835L591 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d928e",
      stroke: "none"
    },
    d: "M621.667 834.333L622.333 834.667L621.667 834.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#679492",
      stroke: "none"
    },
    d: "M637 834L637 835L640 835L637 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085360",
      stroke: "none"
    },
    d: "M391 837L391 838L394 838C392.822 843.093 390.572 850.858 392.717 855.898C396.383 864.508 404.33 854.487 406 850L407 850C407.066 857.731 410.751 861.802 417 855L412 857L412 835L397 855L399 835L391 837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffe6",
      stroke: "none"
    },
    d: "M399 835C397.595 839.489 392.66 853.558 400 854L397 853L399 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e4353",
      stroke: "none"
    },
    d: "M444 840C450.909 838.318 456.079 837.082 457 846C452.666 846.068 447.71 846.32 444.412 849.576C441.165 852.781 441.647 859.343 447.042 859.628C450.685 859.82 453.452 857.196 456 855C457.87 859.716 461.668 859.099 465 856L461 857C459.222 849.12 462.802 829.021 448.1 836.496C446.344 837.389 445.302 838.578 444 840z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003343",
      stroke: "none"
    },
    d: "M508 841C513.065 838.624 515.775 837.381 521 840L519 836C525.32 841.682 521.956 850.487 524 858L522 855L521 855L522 860L529 856L525 857C523.699 851.233 525.712 843.49 523.283 838.216C520.114 831.338 510.522 836.604 508 841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d4d61",
      stroke: "none"
    },
    d: "M531 838L531 839C539.271 841.977 532.178 851.788 536 858C538.343 851.693 544.496 830.395 531 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#709b9a",
      stroke: "none"
    },
    d: "M538 835L539 836L538 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b6168",
      stroke: "none"
    },
    d: "M555 860C554.608 856.67 554.123 853.355 554.026 849.999C553.914 846.093 554.394 841.589 551.916 838.247C550.949 836.943 547.825 834.806 546.929 837.448C546.099 839.894 549.521 842.869 550.297 845.027C552.305 850.61 548.094 857.492 555 860z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004c59",
      stroke: "none"
    },
    d: "M590.011 836.039C578.51 840.924 578.108 865.114 592.972 858.911C603.599 854.475 603.702 830.224 590.011 836.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a6269",
      stroke: "none"
    },
    d: "M605 839L608 838L608 858C616.802 856.114 612.199 840.054 625 840C623.103 831.084 615.778 839.231 614 844C612.59 838.99 610.023 831.354 605 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#024958",
      stroke: "none"
    },
    d: "M636.003 835.958C625.146 840.287 623.265 864.139 637.989 859.211C649.701 855.291 650 830.377 636.003 835.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b5864",
      stroke: "none"
    },
    d: "M519 836L521 846C517.084 846 512.035 845.976 509 848C505.838 850.108 503.827 857.724 508 860C513.612 863.061 516.272 855.533 520 855C520.295 854.958 520.126 859.368 521 855L522 855L524 858C522.456 851.157 525.608 840.1 519 836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbffea",
      stroke: "none"
    },
    d: "M540 836L539 847L540 847L540 836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#011834",
      stroke: "none"
    },
    d: "M569 837L569 838L579 836L569 837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfade",
      stroke: "none"
    },
    d: "M604 836L603 839L608 840L607 860L608 860C608.144 854.935 612.351 839.443 605 839L606 836L604 836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#146a6d",
      stroke: "none"
    },
    d: "M637 836L637 837C643.009 840.135 643.958 844.612 644 851C648.201 844.256 644.912 836.82 637 836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffae4",
      stroke: "none"
    },
    d: "M375 837L372 856L384 855L384 854L374 855L375 837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8ffee",
      stroke: "none"
    },
    d: "M412 837L411 856L415 856L415 855L412 855L412 837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fcde",
      stroke: "none"
    },
    d: "M436 854L436 853C434.412 853.368 432.646 853.981 430.988 853.851C420.687 853.049 427.987 836.176 433 842C434.221 837.284 429.337 837.129 426.729 840.227C419.981 848.242 426.199 858.419 436 854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d988f",
      stroke: "none"
    },
    d: "M438.333 837.667L438.667 838.333L438.333 837.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9c7b8",
      stroke: "none"
    },
    d: "M450 837L450 838L454 838L450 837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6ffe7",
      stroke: "none"
    },
    d: "M508 841L508 842C514.055 840.072 522.33 842.691 513 845L513 846L520 846C519.798 836.929 514.926 836.597 508 841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a9794",
      stroke: "none"
    },
    d: "M407 838L407 841L408 841L407 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e9995",
      stroke: "none"
    },
    d: "M427 838L428 839L427 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f646c",
      stroke: "none"
    },
    d: "M460 838L460 846L461 846L460 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#286f75",
      stroke: "none"
    },
    d: "M524 838L524 846L525 846L524 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003343",
      stroke: "none"
    },
    d: "M545 838L535 856L534 856C535.491 862.924 544.17 844.134 546 841L547 841L550 856L551 856C551 848.427 551.362 843.052 545 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75b0a0",
      stroke: "none"
    },
    d: "M636 838L636 839L639 839L636 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84a194",
      stroke: "none"
    },
    d: "M374 839L374 842L375 842L374 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#629794",
      stroke: "none"
    },
    d: "M411 839L411 842L412 842L411 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f1dc",
      stroke: "none"
    },
    d: "M494 839C496.215 842.114 500.481 845.824 499.972 849.999C498.752 860.026 479.549 864.555 480 852C489.12 858.988 503.136 850.593 491 844C491.513 844.85 492.494 846.192 492.893 847.199C497.889 859.797 476.125 846.957 478.015 855.969C480.544 868.027 510.749 857.763 499.492 843.101C497.968 841.116 496.164 840.105 494 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfee9",
      stroke: "none"
    },
    d: "M533 839L533 855L534 855C534.632 850.157 536.777 842.813 533 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41808a",
      stroke: "none"
    },
    d: "M559 839L559 840L563 840L559 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffe8",
      stroke: "none"
    },
    d: "M563 839L559 840L559 841L563 841C561.628 847.084 561.393 853.252 564 859L565 859L563 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfbea",
      stroke: "none"
    },
    d: "M568 839C568 846.426 565.888 858.96 577 854L577 853C567.306 855.133 569.08 847.044 570 840L576 840L568 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfadf",
      stroke: "none"
    },
    d: "M583 839C577.49 850.016 580.303 867.457 596 859L596 858C580.36 862.193 579.63 850.366 585 839L583 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcf9e9",
      stroke: "none"
    },
    d: "M589.297 840.192C583.906 843.178 585.284 859.38 592.717 855.749C599.223 852.571 597.488 835.654 589.297 840.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfbe4",
      stroke: "none"
    },
    d: "M601 839L598 856C602.722 851.594 604.558 844.711 601 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f2da",
      stroke: "none"
    },
    d: "M642 848L641 848C639.805 852.989 634.042 856.302 633.29 848.985C632.706 843.304 637.668 839.362 641 845C642.946 836.873 632.126 839.739 631.334 847.001C630.222 857.204 641.191 858.819 642 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7aa196",
      stroke: "none"
    },
    d: "M369 840L369 843L370 843L369 840z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#709c94",
      stroke: "none"
    },
    d: "M444.667 840.333L445.333 840.667L444.667 840.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a858b",
      stroke: "none"
    },
    d: "M456 840L456 846L457 846L456 840z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#629793",
      stroke: "none"
    },
    d: "M520 840L520 846L521 846L520 840z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#559593",
      stroke: "none"
    },
    d: "M535 840L535 845L536 845L535 840z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8e0c8",
      stroke: "none"
    },
    d: "M590.256 841.366C585.894 843.266 585.732 855.707 591.744 854.067C596.843 852.676 595.804 838.948 590.256 841.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83a5a0",
      stroke: "none"
    },
    d: "M618 840L619 841L618 840z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6e1c6",
      stroke: "none"
    },
    d: "M641 848L642 848L642 850L643 850L643 842L642 842L642 845C637.147 837.72 631.381 843.894 633.416 850.898C635.436 857.855 640.411 852.176 641 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefbe2",
      stroke: "none"
    },
    d: "M420 841C418.486 845.253 418.873 851.201 416.283 854.85C411.121 862.121 407.133 855.961 407 850L406 850C398.69 863.368 392.002 857.342 392 845L391 845C389.583 855.865 394.011 865.855 405 856C409.428 863.264 413.732 858.748 420 857L420 841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82aba6",
      stroke: "none"
    },
    d: "M434.667 841.333L435.333 841.667L434.667 841.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfbe5",
      stroke: "none"
    },
    d: "M546 841L537 860L538 860L548 842L546 841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7ba695",
      stroke: "none"
    },
    d: "M601 842L601 847L602 847L601 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e656f",
      stroke: "none"
    },
    d: "M422 843L421 848L420 848L420 846L419 846L419 854L420 854L420 852L421 852C422.224 858.106 426.556 857.985 432 858L432 857C422.934 856.06 423.822 849.938 422 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064955",
      stroke: "none"
    },
    d: "M492 843C497.097 850.904 494.506 855.421 485 856L485 857L493 857L493 858C487.483 857.996 481.964 858.573 481 852L480 852C478.485 860.815 489.051 861.263 494.926 857.774C500.102 854.701 500.413 849.234 499 844L498 844L499 852L498 852C497.533 847.471 496.035 845.135 492 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97aaa6",
      stroke: "none"
    },
    d: "M647 843L647 847L648 847L647 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97b7ab",
      stroke: "none"
    },
    d: "M563 844L563 849L564 849L563 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3baad",
      stroke: "none"
    },
    d: "M396.333 845.667L396.667 846.333L396.333 845.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83b2a5",
      stroke: "none"
    },
    d: "M585 845L585 851L586 851L585 845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91baad",
      stroke: "none"
    },
    d: "M373.333 846.667L373.667 847.333L373.333 846.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6ba59c",
      stroke: "none"
    },
    d: "M513.667 846.333L514.333 846.667L513.667 846.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#639991",
      stroke: "none"
    },
    d: "M500 847L500 851L501 851L500 847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d969a",
      stroke: "none"
    },
    d: "M538 847L538 849L540 847L538 847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#769c94",
      stroke: "none"
    },
    d: "M368.333 848.667L368.667 849.333L368.333 848.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8183",
      stroke: "none"
    },
    d: "M451 848L451 849L454 849L451 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffe8",
      stroke: "none"
    },
    d: "M456 848C439.948 851.181 453.036 860.583 456 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73a296",
      stroke: "none"
    },
    d: "M515.667 848.333L516.333 848.667L515.667 848.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcf9e7",
      stroke: "none"
    },
    d: "M519 851L512 855L511 854L511 852L520 848C506.114 849.933 513.911 860.081 519 851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d9b96",
      stroke: "none"
    },
    d: "M626 848L626 853L627 853L626 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b8f89",
      stroke: "none"
    },
    d: "M563 849L563 854L564 854L563 849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5c6b5",
      stroke: "none"
    },
    d: "M580 849L580 853L581 853L580 849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ced8c5",
      stroke: "none"
    },
    d: "M447 852L447 854L448 855L454 850L447 852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cddccb",
      stroke: "none"
    },
    d: "M511 852L511 854L512 855L520 852C517.234 849.294 514.241 850.534 511 852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#418880",
      stroke: "none"
    },
    d: "M596.333 850.667L596.667 851.333L596.333 850.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b8e90",
      stroke: "none"
    },
    d: "M445.333 852.667L445.667 853.333L445.333 852.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a6f6f",
      stroke: "none"
    },
    d: "M436 853L438 855L438 853L436 853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfee5",
      stroke: "none"
    },
    d: "M438 853C434.184 857.881 430.145 859.785 424 860L424 861C429.258 860.966 438.838 860.294 438 853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#307374",
      stroke: "none"
    },
    d: "M441 853L441 857L442 857L441 853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#157271",
      stroke: "none"
    },
    d: "M481 853C481.338 859.208 488.2 857.999 493 858L493 857L481 853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78a59c",
      stroke: "none"
    },
    d: "M505 853L505 856L506 856L505 853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58978e",
      stroke: "none"
    },
    d: "M608 853L608 856L609 856L608 853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002840",
      stroke: "none"
    },
    d: "M611 853L608 858L608 859L612 859L611 853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4b8080",
      stroke: "none"
    },
    d: "M612 853L612 856L613 856L612 853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcf8e7",
      stroke: "none"
    },
    d: "M455 855C449.982 859.323 446.914 860.141 441 857C444.319 862.691 449.495 862.208 454 858L455 858L463 860L463 859L455 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffe7",
      stroke: "none"
    },
    d: "M519 855C513.982 859.323 510.914 860.141 505 857C508.89 863.67 514.343 860.957 520 858L525 861L525 860L519 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003240",
      stroke: "none"
    },
    d: "M558 855L554 858L554 859L558 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#719793",
      stroke: "none"
    },
    d: "M574 855L575 856L574 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98ada9",
      stroke: "none"
    },
    d: "M412.667 856.333L413.333 856.667L412.667 856.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74a398",
      stroke: "none"
    },
    d: "M555.667 856.333L556.333 856.667L555.667 856.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78a59c",
      stroke: "none"
    },
    d: "M641 857L642 858L641 857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77aca3",
      stroke: "none"
    },
    d: "M573 858L574 859L573 858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80a398",
      stroke: "none"
    },
    d: "M368 859L368 860L378 860L368 859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43797e",
      stroke: "none"
    },
    d: "M458.667 859.333L459.333 859.667L458.667 859.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93bbaf",
      stroke: "none"
    },
    d: "M490.667 859.333L491.333 859.667L490.667 859.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fa49e",
      stroke: "none"
    },
    d: "M551 859L552 860L551 859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e8282",
      stroke: "none"
    },
    d: "M608.667 859.333L609.333 859.667L608.667 859.333z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.65a3aa926b7ad7fcd1ecceeb9433d406.svg";
export { ForwardRef as ReactComponent };